import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  assign as _assign,
  cloneDeep as _cloneDeep,
  defer as _defer,
  filter as _filter,
  find as _find,
  forEach as _forEach,
  get as _get,
  indexOf as _indexOf,
  isNil as _isNil,
  isEmpty as _isEmpty,
  map as _map,
  maxBy as _maxBy,
  minBy as _minBy,
  orderBy as _orderBy,
  uniq as _uniq,
  compact as _compact,
  isArray as _isArray,
  some as _some,
  isEqual as _isEqual,
  difference as _difference,
  every as _every,
  delay as _delay,
  includes as _includes,
} from 'lodash';
import {
  BlApiConditionHelper,
  BlApiErrorInfo,
  BlApiQueryParams,
  BlApiSearchCondition,
  BlAppContext,
  BlConditionInfo,
  BlConditionType,
  BlListResponseBody,
  BlUrlQuery,
  BlUrlQueryKey,
  HttpStatus,
} from '@blcloud/bl-ng-common';
import {
  BizMenuResource,
  DepositListSearchConditionResource,
  ItemServiceSettingResource,
  RepairSlipQuantityManageResource,
  SfSlipCountMgtResource,
  CsSlipCountMgtResource,
  PayListSearchConditionResource,
  PurchaseSlipInfoSearchResource,
  PayoutMoveSlipInfoSearchResource,
  SharedVehicleStockTransInfoResource,
  SharedVehicleStockInfoResource,
} from '@blcloud/bl-ng-resource';
import {
  AddOptionModalComponent,
  FunctionRole,
  LoginResourceService,
  PageId,
  ScreenService,
  TutorialModalComponent,
  FnKey,
  SpaStraddleConst,
  OemCustomizeItemId,
  FunctionRef,
  TransitionConciergeModalRequest,
  TransitionType,
  TransitionConciergeModalComponent,
  ReportOutputStatusGuideComponent,
  PermissionCondition,
  EditMode,
  IsshinTasukeMenuSettingModalComponent,
} from '@blcloud/bl-ng-share-module';
import {
  IBizMenu,
  IItemServiceSetting,
  ILoginUserEmployeeBindModel,
  IRepairSlipQuantityManage,
  ISfSlipCountMgt,
  IPermissionCheck,
  IMasterAutoInsert,
  IServiceAvailabilityInfo,
  ICsSlipCountMgt,
  IOemCustomize,
  IDiagnosisResultInfo,
  IPurchaseSlipInfoSearch,
  IExportPatternInfo,
  IIsshinTasukeMenuGroup,
  IIsshinTasukeMenuContent,
  IIsshinTasukeMenuSetting,
  ISharedVehicleStockCountMgt,
  ISharedVehicleStockInfo,
  ISharedVehicleStockSearchReq,
} from '@blcloud/bl-datamodel';
import {
  BlDialogService, BlLoadingService,
  BlModalRef,
  BlModalService,
  BlTabContainerService,
  DialogColor,
  DialogIcon,
  ModalButtonType,
  ModalReason,
  ModalButtonColor,
  BlTabContainerComponent,
  BlTabMultiStage,
  DialogOption,
  ModalButton,
  ModalOption,
  BlOverlayAlertService,
  AlertType,
  ModalSize,
} from '@blcloud/bl-ng-ui-component';
import { ContractConst } from '@blcloud/bl-datamodel/const/contract';
import { RoleConst } from '@blcloud/bl-datamodel/const/role';
import { CompanyConst } from '@blcloud/bl-datamodel/const/company';
import { LogicalDeleteDiv } from '@blcloud/bl-datamodel/enum/common/logical-delete-div';
import { DraftFixedStatusDiv } from '@blcloud/bl-datamodel/enum/bizcmn/draft-fixed-status-div';
import { DomSanitizer } from '@angular/platform-browser';
import { SfSlipKindArray } from '@blcloud/bl-datamodel/enum/sales/sf-slip-kind';
import { CsSlipKindArray } from '@blcloud/bl-datamodel/enum/sales/cs-slip-kind';
import { of as ObservableOf } from 'rxjs/observable/of';
import { filter, map, mergeMap, skipWhile, take, tap, skip, catchError } from 'rxjs/operators';
import { SlipKind, SlipKindArray } from '@blcloud/bl-datamodel/enum/sales/slip-kind';
import { SharedVehicleStockStatus } from '@blcloud/bl-datamodel/enum/stock/shared-vehicle-stock-status';
import { BusinessMenuStatus } from '@blcloud/bl-datamodel/enum/bizcmn/business-menu-status';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { combineLatest as ObservableCombineLatest } from 'rxjs/observable/combineLatest';
import { forkJoin as ObservableForkJoin } from 'rxjs/observable/forkJoin';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, convertToParamMap } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ProductCode } from '@blcloud/bl-datamodel/enum/common/product-code';
import { RightAndLeftDiv } from '@blcloud/bl-datamodel/enum/sales/right-and-left-div';
import {
  SessionStorageUtils,
  LocalStorageUtils,
  Const,
  UrlUtils,
  DateTimeUtils,
  DateTimeOutput,
  DateTimePadding,
  DateSeparator,
} from '@blcloud/bl-common';
import { BizMenuPageService } from './biz-menu-page.service';
import { MasterAutoInsertResultDiv } from '@blcloud/bl-datamodel/enum/bizcmn/master-auto-insert-result-div';
import { BizMenuNotIntroducedDisplayDiv } from '@blcloud/bl-datamodel/enum/bizcmn/biz-menu-not-introduced-display-div';
import { CutoffSettledSlipDiv } from '@blcloud/bl-datamodel/enum/credit/cutoff-settled-slip-div';
import { DisplayUnit } from '@blcloud/bl-datamodel/enum/managementreport/display-unit';
import { NotificationLevel } from '@blcloud/bl-datamodel/enum/notification/notification-level';
import { PagePath } from '@blcloud/bl-ng-menu-common-module';
import { YahooWarnModalComponent } from './yahoo-warn-modal/yahoo-warn-modal.component';
import { fromEvent as RxFromEvent } from 'rxjs/observable/fromEvent';
import { YahooPublicKeyWarnModalComponent } from './yahoo-publickey-warn-modal/yahoo-publickey-warn-modal.component';
import {
  DepositScreenType,
  PaymentScreenType,
  BiTaskRunStatus,
  BlPartsOrderMenuContentId,
  BubbleFnRole,
  MAINTENANCE_TARGET_PAGE_IDS,
  ButtonLabels,
  ACTIVE_TAB_IDS,
  NAVIGATION_RULES,
  DIV_LOOKUP_CONFIG,
  SF_REPAIR_OUTPUT_HISTORY_TRANSITION_RULES,
  SLIP_SEARCH_URL_PATHS,
  REPAIR_SLIP_SERVICE_IDS,
  RECEPTION_ROUTE_SERVICE_IDS,
  MaintenanceRepairMenuContentId,
  MaintenanceTabId,
  DiagnosisResultInfoState,
  BusinessMenuGroupId,
  IsshinTasukeTabOption,
  SharedVehicleStockConsiderationSearchPageSize,
} from './biz-menu-page.const';
import {
  IBizMenuPageScreenActionSetting, ReceptionNavigationDiv, SLIP_NAVIGATION_PROPERTY
} from '../../feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.define';
import {
  BizMenuPageScreenActionSettingService
} from '../../feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.service';
import {
  BizMenuPageScreenActionSettingModalComponent
} from '../../feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.component';
import { CustomerVehicleSearchDispDiv } from '@blcloud/bl-ng-vehicle-customer-module';
import { DepositUrlLinkDiv } from '@blcloud/bl-datamodel/enum/credit/deposit-url-link-div';
import { ExportInfoTabDiv } from '@blcloud/bl-datamodel/enum/output/export-info-tab-div';
import { ExportInfoDiv } from '@blcloud/bl-datamodel/enum/output/export-info-div';
import { ExportWorkTypeDiv } from '@blcloud/bl-datamodel/enum/output/export-work-type-div';
import {
  ExportPatternCodeConstant,
  IExportPatternModalParams
} from '../../feature/export-modal/export-pattern-modal/export-pattern-modal.define';
import { ExportPatternModalComponent } from '../../feature/export-modal/export-pattern-modal/export-pattern-modal.component';
import { BizMenu, BizMenuContentEx, BizMenuGroup, BizMenuItem, BizMenuLine, BizMenuTabOption } from './biz-menu-page.interface';
import { IsshinTasukeMenuService } from './isshin-tasuke-menu/isshin-tasuke-menu.service';
import { IDispIsshinTasukeMenuData } from './isshin-tasuke-menu/isshin-tasuke-menu.interface';
import { IsshinTasukeBusinessTabDiv } from '@blcloud/bl-datamodel/enum/bizcmn/isshin-tasuke-business-tab-div';
import { IsshinTasukeBusinessTabDefaultDiv } from '@blcloud/bl-datamodel/enum/bizcmn/isshin-tasuke-business-tab-default-div';
import { OfferUserDataDiv } from '@blcloud/bl-datamodel/enum/common/offer-user-data-div';

@Component({
  selector: 'app-biz-menu-page',
  templateUrl: './biz-menu-page.component.html',
  styleUrls: ['./biz-menu-page.component.scss'],
})
export class BizMenuPageComponent implements OnInit, AfterViewInit, OnDestroy {
  BusinessMenuStatus: typeof BusinessMenuStatus = BusinessMenuStatus;

  /** 契約管理Const定義 */
  readonly ContractConst = ContractConst;

  readonly StaticBusinessMenuGroupId: {
    [ServiceId: string]: {
      [key: string]: number;
    };
  } = {
      [ContractConst.SERVICEID_PRODUCT_MAINTENANCE]: {
        report: 2,
      }
    };

  @Input() telQuery = '';
  @Input() customerQuery = '';
  @Input() vehicleQuery = '';
  @Input() salesQuery = '';

  private readonly badgeInterval = 5 * 60 * 1000; // 5分毎に更新

  /** 件数バッヂ許可フラグキー */
  private readonly COUNT_BADGE_ALLOW_FLAG_KEY = 'countBadgeAllowFlag';

  badge: {
    [key: string]: {
      [value: string]: {
        final?: number;
        draft?: number;
      }
    };
  } = {
      sfSlip: {},
      deposit: {}, // 入金
      repairSlip: {},
      csSlip: {},
      purchaseSlip: {}, // 仕入伝票
      payoutMoveSlip: {}, // 払出移動伝票
      blPayAffiliated: {}, // BLPay(加盟店)
      blPaySuppliers: {}, // BLPay(取引先)
      partsOrder: {},
      sharedVehicleStock: {}, // 共有車両在庫
    };

  existBadge: {
    [key: string]: {
      [value: string]: boolean;
    };
  } = {
      sfSlip: {},
      deposit: {},
      repairSlip: {},
      csSlip: {},
      purchaseSlip: {},
      payoutMoveSlip: {},
      blPayAffiliated: {},
      blPaySuppliers: {},
      partsOrder: {},
      sharedVehicleStock: {},
    };

  nsBadge: {
    [key: string]: {
      [value: string]: boolean;
    };
  } = {
      sfSlip: {},
    };

  private timer: { [key: string]: any } = {};
  private currentTarget: any;
  private isCurrentFocus = false;

  /** タブ */
  tabOptions: BizMenuTabOption[] = [];
  /** タブバックアップ */
  private tabOptionsBackup: BizMenuTabOption[] = [];
  /** 業務メニュー */
  bizMenuGroup: BizMenuGroup = {};
  /** 選択中タブ */
  currentTab: BizMenuTabOption;
  /** 選択中タブID */
  currentTabId: string;

  organizationCode: string;

  blTenantId: string;

  eventIds: string[];
  /** 予約ボタン非表示フラグ */
  hideReserveBtn = false;
  /** スケジュールフッター非表示フラグ */
  hideScheduleFooter = false;

  private readonly initializedSubject = new BehaviorSubject(false);

  private subscriptions: Subscription[] = [];
  private selectTabSubscription: Subscription;
  /** ログイン状態の変更監視購読 */
  private changeLoginStatusSubscription: Subscription;

  /** 出力パターン項目リスト */
  private _exportPatternItems: IExportPatternInfo;

  /** ログインユーザー情報 */
  private loginUser: ILoginUserEmployeeBindModel;

  /** 出力パターン選択情報 */
  private selectExportPatterns: { [key: string]: number; };

  /** バッジの凡例を**非表示**にするタブ */
  hiddenExplanatoryNotes: {
    /** 下書きバッジ(青) */
    draft: number[],
    /** 次工程待ちバッジ(赤) */
    stay: number[],
  } = {
      draft: [
        BusinessMenuGroupId.StockTabPartsman,
        BusinessMenuGroupId.StockTabRecycle,
        BusinessMenuGroupId.GlassTabRecycle,
        BusinessMenuGroupId.CreditTab,
        BusinessMenuGroupId.CreditTabGlass,
        BusinessMenuGroupId.CreditTabPartsman,
        BusinessMenuGroupId.PmEstimateSearch,
        BusinessMenuGroupId.PmBillMngTab,
        BusinessMenuGroupId.DebtTabPartsman,
        BusinessMenuGroupId.GlassTabGlass,
        BusinessMenuGroupId.PerformanceTabRecycle,
        BusinessMenuGroupId.PricePrint,
        BusinessMenuGroupId.DebtGlass,
        BusinessMenuGroupId.BLPaySuppliers,
        BusinessMenuGroupId.DeliveryPf,
      ],
      stay: [
        BusinessMenuGroupId.StockTabPartsman,
        BusinessMenuGroupId.StockTabRecycle,
        BusinessMenuGroupId.CreditTab,
        BusinessMenuGroupId.CreditTabPartsman,
        BusinessMenuGroupId.CreditTabRecycle,
        BusinessMenuGroupId.DebtTabPartsman,
        BusinessMenuGroupId.GlassTabGlass,
        BusinessMenuGroupId.DebtTabRecycle,
        BusinessMenuGroupId.CreditTabGlass,
        BusinessMenuGroupId.GlassTabRecycle,
        BusinessMenuGroupId.PmEstimateSearch,
        BusinessMenuGroupId.PmBillMngTab,
        BusinessMenuGroupId.PerformanceTabRecycle,
        BusinessMenuGroupId.PricePrint,
        BusinessMenuGroupId.DebtGlass,
        BusinessMenuGroupId.BLPayAffiliated,
        BusinessMenuGroupId.DeliveryPf,
      ],
    };

  /** 使い方ダイアログ表示フラグ */
  private isShownTutorialModal = false;

  /** 権限なし機能リスト */
  private permissionList: IPermissionCheck[];

  /** 有効なサービスIDリスト */
  private availableServiceList: string[];

  /** 権限なしマスク表示有無 */
  _showPermissionMask = false;

  /** 業務メニューコンテンツID(ご案内) */
  private readonly BUSINESS_MENU_CONTENT_ID_GUIDANCE = 13;

  /** 業務メニューコンテンツID(接客提案) */
  private readonly BUSINESS_MENU_CONTENT_ID_CONTACT_SCHEDULE = 15;

  /** 業務メニューグループID(整備) */
  private readonly BUSINESS_MENU_GROUP_ID_SF = 1;

  /** OEMカスタマイズ情報 */
  private oemCustomize: IOemCustomize;

  /** OEMサイトリンクリスト */
  private oemSiteLinkList: { fnRole: FunctionRole, url: string }[] = [];

  /** OEMバブルメニューリスト */
  private oemBubbleMenuList: any[] = [];

  /** OEM背景色 */
  _oemBackgroundColor = '';

  /** OEMBLシグネチャー */
  _oemSignature = false;

  /** 今月の実績情報 */
  _diagnosisResultInfo: IDiagnosisResultInfo = {
    actualCount: 0,
    goalVcleCnt: 0,
    actualPriceTotal: 0,
    goalPriceTotal: 0,
  };

  /** 実績情報表示切り替え値 */
  _diagnosisResultInfoState = DiagnosisResultInfoState.Reading;

  /** 金額単位表示形式 */
  _amountUnit = DisplayUnit.SenYen;

  /** サービス状態 */
  _isAvailableService: { [serviceId: string]: boolean } = {};

  /** BIツール連携サービス契約有無 */
  _isAvailableBiTool = false;

  /** BIツール連携サービス契約有無(PM) */
  _isAvailableBiToolPm = false;

  /**
   * 現在のタブがローンタブかどうかを判定
   * @returns ローンタブの場合true、それ以外false
   */
  get isLoanTab(): boolean {
    if (!this.currentTab) {
      return false;
    }
    return this.currentTab.serviceId === ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK ||
           this.currentTab.serviceId === ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR ||
           this.currentTab.serviceId === ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE;
  }

  /** タブnav項目非表示フラグ */
  _isHideTabNavItem = false;

  /** タブ多段表示区分 */
  _multiStage = BlTabMultiStage.None;

  /** アコーディオンコンテンツ表示フラグ */
  showAccordionContentFlg = false;

  /** 実績情報読み込みステータス */
  readonly DiagnosisResultInfoState = DiagnosisResultInfoState;

  /** 入金用メッセージ表示フラグ */
  private _isDepositMessageDisp = true;

  /** 出金用メッセージ表示フラグ */
  private _isPaymentMessageDisp = true;

  /** Pm.c用データ出力フラグ */
  _isPmcDataOutput = false;

  /** Yahoo連携サービス利用可能フラグ */
  private relationYahoo = false;

  /** ログイン直後かどうかのローカルストレージキー */
  private readonly IMMEDIATELY_AFTER_LOGIN_STORAGE_KEY = 'immediatelyAfterLogin';

  /** ログイン直後かどうか判断するフラグ */
  private isFirstLogin = false;

  /** PSユーザーコード設定有無 */
  private hasPsUserCode = false;

  /** 契約管理照会ID */
  private contractInquiryId: string;

  /** 画面動作設定 */
  private screenActionSetting: IBizMenuPageScreenActionSetting;

  // 画面動作設定を適用するために、利用可能なメンテナンス関連プロダクトコード（整備、鈑金、車販）を取得し、
  // この配列を使って、特定の画面でのアクション（例：カスタム設定メニューの表示、URLの動的変更）を制御します。
  private maintenanceProductArr: string[];

  /** AVISアドオン基本サービスの有無 */
  private isAvisAddonAvailable = false;

  /** ローン申込外部連携サービスの有無 */
  private isCmnLoanExternallinkAvailable = false;

  /** ローン申込単独利用サービスの有無 */
  private isCmnLoanSingleAvailable = false;

  /** 証跡帳票自動登録サービスの利用可否 */
  private isCaseEvidenceAutoRegistAvailable = false;

  // .subscribe関数内で使用すると、ビルドエラーになるため、自コンポーネントの公開プロパティとして再定義する。
  // コンポーネントの外部で定義されたAlertTypeが見つからないためビルドエラーになる模様。
  public readonly AlertType = AlertType;

  /** タブコンテナ */
  @ViewChild('blTabContainer') tabContainer: BlTabContainerComponent;

  /** 予約機能として利用するサービスID */
  _useReserveServiceId = ContractConst.SERVICEID_OPT_CMN_RESERVE_MGT;

  private exportInfoTabDiv = ExportInfoTabDiv.Excluded;

  /** タブID定義 */
  readonly MaintenanceTabId = MaintenanceTabId;

  /** タジマサービス契約有無 */
  private isAvailableTajima = false;
  /** 業務メニューグループリスト */
  private businessGroupList?: IIsshinTasukeMenuGroup[];
  /** 全業務メニューリスト */
  private businessAllMenuList?: IIsshinTasukeMenuContent[];
  /** 一新多助メニュー表示データ */
  _dispIsshinTasukeMenuData: IDispIsshinTasukeMenuData = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sfSlipCountMgtResource: SfSlipCountMgtResource,
    private screenService: ScreenService,
    private loginResourceService: LoginResourceService,
    private itemServiceSettingResource: ItemServiceSettingResource,
    private bizMenuResource: BizMenuResource,
    private depositListSearchConditionResource: DepositListSearchConditionResource,
    private tabContainerService: BlTabContainerService,
    private dialogService: BlDialogService,
    private modalService: BlModalService,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private repairSlipQuantityManageResource: RepairSlipQuantityManageResource,
    private loadingService: BlLoadingService,
    private pageService: BizMenuPageService,
    private csSlipCountMgtResource: CsSlipCountMgtResource,
    private payListSearchConditionResource: PayListSearchConditionResource,
    private purchaseSlipInfoSearchResource: PurchaseSlipInfoSearchResource,
    private payoutMoveSlipInfoSearchResource: PayoutMoveSlipInfoSearchResource,
    private appContext: BlAppContext,
    private sharedVehicleStockTransInfoResource: SharedVehicleStockTransInfoResource,
    private sharedVehicleStockInfoResource: SharedVehicleStockInfoResource,
    private screenActionSettingService: BizMenuPageScreenActionSettingService,
    private overlayAlertService: BlOverlayAlertService,
    private isshinTasukeMenuService: IsshinTasukeMenuService,
  ) {
  }

  /**
   * 初期化
   */
  ngOnInit() {
    SessionStorageUtils.remove(SpaStraddleConst.PROCESSBOARD_RESTORE_QUERY);
    SessionStorageUtils.remove(SpaStraddleConst.PROCESS_SEACH_CONDITION_SETTING);

    // ログイン直後かどうかを判断
    this.isFirstLogin = LocalStorageUtils.get(this.IMMEDIATELY_AFTER_LOGIN_STORAGE_KEY);
    LocalStorageUtils.remove(this.IMMEDIATELY_AFTER_LOGIN_STORAGE_KEY);

    this.screenService.showFrame();
    this.subscriptions.push(
      this.route.fragment
        .subscribe((fragment: string) => {
          this.selectTab(fragment);
          this.changeLoginStatus();
        })
    );

    // バッジデータ初期化
    this.clearBadge();

    // 通知案内を表示
    this.showNotificationGuide();

    // 組織が決定していることを確認してマスターデータ不備チェックを行う
    // 組織不定時は、HeaderComponentが従業員紐づけを行い、loginUserEmployeeBindModelの再取得を行う
    // それをここで検知してマスターデータ不備チェックにつなげる
    const loginUserSub = this.loginResourceService.loginUserEmployeeBindModel$.subscribe(
      (loginUser: ILoginUserEmployeeBindModel) => {
        if (_isNil(loginUser) || !loginUser.organizationCode) {
          return; // ユーザと組織が特定されるまでは、なにもしない
        }

        // 今月の実績情報を取得
        this.pageService.getThisMonthDiagnosisResultInfo(loginUser).subscribe(
          diagnosis => {
            if (diagnosis) {
              this._amountUnit = diagnosis.amountUnit;
              this._diagnosisResultInfo = diagnosis;
              this._diagnosisResultInfoState = DiagnosisResultInfoState.Success;
            } else {
              this._diagnosisResultInfoState = DiagnosisResultInfoState.NoData;
            }
          },
          () => {
            this._diagnosisResultInfoState = DiagnosisResultInfoState.Fail;
          }
        );

        // 組織が確定したら、マスターデータ不備チェックを行う
        this.loginResourceService.getAllServiceAvailabilityInfo().subscribe(
          (infos: IServiceAvailabilityInfo[]) => {
            this.pageService.fixMasterIfNeed(infos.map(info => info.serviceId));
          }
        );
        // 一度だけ実行できればよいので、購読を破棄する
        if (!_isNil(loginUserSub) && !loginUserSub.closed) {
          loginUserSub.unsubscribe();
        }

        this.loginUser = loginUser;
      }
    );

    // ログインしている従業員に紐づくデータを初期化
    const subscription = ObservableCombineLatest(
      this.loginUserEmployeeBindModel$,
      this.bizMenu$,
      this.loginResourceService.changeUnavailablePermissionList(),
      this.loginResourceService.getAllServiceAvailabilityInfo(),
      this.pageService.isRegisteredPsUserCode(),
      this.pageService.getContractCompanyInfo()
    )
      .pipe(
        skipWhile(([loginUserEmployeeBindModel, bizMenu]) => {
          return _isNil(loginUserEmployeeBindModel) || _isNil(bizMenu);
        }),
        map(([loginUserEmployeeBindModel, bizMenu, permissionList, availabilityInfo, hasPsUserCode, contractCompanyInfo]) => {

          this.organizationCode = loginUserEmployeeBindModel.organizationCode;
          this.blTenantId = loginUserEmployeeBindModel.blTenantId;
          this.hasPsUserCode = hasPsUserCode;
          this.contractInquiryId = contractCompanyInfo.contractInquiryId;

          // 権限なしリスト保持
          this.permissionList = permissionList;

          // 整備を表示する
          const { productCode, bizMenuGroup, tabOptions } = bizMenu;
          this.bizMenuGroup = bizMenuGroup;
          this.tabOptions = tabOptions;

          // 車販用の処理（オプションによるタブ表示のため）
          const availabilities = _compact(_map(availabilityInfo, availability => availability.serviceId));
          this.availableServiceList = availabilities;
          const csData = _filter(this.tabOptions,
            tabOption => ProductCode.CarSales === tabOption.productCode
          );
          const isShowDebtTabRepair = _some(this.tabOptions,
            tabOption => (tabOption.tabId === BusinessMenuGroupId.DebtTabRepair.toString()
              && tabOption.serviceId === ContractConst.SERVICEID_OPT_CMN_PURCHASE_MAINTENANCE_REPAIR
              && tabOption.menuGroup.businessMenuStatus === BusinessMenuStatus.Available)
          );
          if (!_isNil(csData) && csData.length > 1) {
            const newTabOptions = [];
            _forEach(this.tabOptions, tabOption => {
              // 出金伝票タブ用処理
              if (tabOption.tabId === BusinessMenuGroupId.DebtTabCarsales.toString()) {
                // 出金伝票タブが被る場合は整備を優先して使用
                if (!isShowDebtTabRepair && availabilities.includes(ContractConst.SERVICEID_OPT_CMN_CARSALES_PURCHASE)) {
                  newTabOptions.push(tabOption);
                }
                // 車販タブ用処理
              } else {
                if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_CARSALES_VEHICLESTOCK &&
                  ContractConst.SERVICEID_OPT_CMN_CARSALES_PURCHASE)) {
                  if (tabOption.productCode === ProductCode.CarSales &&
                    tabOption.tabId !== BusinessMenuGroupId.Vehiclepurchase.toString()) {
                    // 重複する場合在庫OPのもののみ使用
                  } else {
                    newTabOptions.push(tabOption);
                  }
                } else {
                  if (tabOption.productCode === ProductCode.CarSales &&
                    tabOption.tabId !== BusinessMenuGroupId.Carsales.toString()) {
                    // 重複する場合見積注文OPのもののみ使用
                  } else {
                    newTabOptions.push(tabOption);
                  }
                }
              }
            });
            this.tabOptions = newTabOptions;
          }

          // ローン申込外部連携サービス、ローン申込JOCAR連携サービス、ローン申込単独利用サービス有無によるタブ制御
          if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK)
            || availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR)
            || availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE)
          ) {
            const newTabOptionsLoanExternallink = [];

            let tabOption = null;
            // サービスに応じた「ローン」タブを追加
            if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE)) {
              // ローン単独申込のローンタブ
              // ※NS連携＋ローン単独申込の場合は、ローン単独申込のローンタブを開く
              // ※NS連携のローンタブにはローン申込アイコンがないため（NS連携でのみ表示するアイコンは特にない）
              tabOption = _find(this.tabOptions, _tabOption => _tabOption.serviceId === ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE);
            } else if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK)) {
              // NS連携のローンタブ
              tabOption = _find(this.tabOptions, _tabOption => _tabOption.serviceId === ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK);
            } else if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR)) {
              // JOCAR連携のローンタブ
              tabOption = _find(this.tabOptions, _tabOption => _tabOption.serviceId === ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR);
            }
            if (tabOption) {
              newTabOptionsLoanExternallink.push(tabOption);
            }

            // プライスボード有効時は「プライスボード」タブを追加
            if (availabilities.includes(ContractConst.SERVICEID_PRODUCT_PRICEPRINT)) {
              tabOption = _find(this.tabOptions, _tabOption => _tabOption.serviceId === ContractConst.SERVICEID_PRODUCT_PRICEPRINT);
              if (tabOption) {
                newTabOptionsLoanExternallink.push(tabOption);
              }
            }

            // 「ローン」タブを表示するときは（「プライスボード」タブ以外の）他のタブを表示しない
            // ただしJOCAR連携サービス契約時のみ「整備」「鈑金」タブをローンタブと共存させる
            const maintenanceTab = _find(
              this.tabOptions,
              _tabOption => _tabOption.serviceId === ContractConst.SERVICEID_PRODUCT_MAINTENANCE
            );
            const repairTab = _find(this.tabOptions, _tabOption => _tabOption.serviceId === ContractConst.SERVICEID_PRODUCT_REPAIR);

            // JOCAR連携の場合
            if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR)) {
              // 整備タブが有効かつ整備サービスありの場合 または 鈑金タブが有効の場合、外部連携・単独申込の「ローン」を除外
              if ((maintenanceTab && availabilities.includes(ContractConst.SERVICEID_OPT_MAINTENANCE_BASE)) || repairTab) {
                this.tabOptions =
                _filter(this.tabOptions, option =>
                  option.serviceId !== ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK
                  && option.serviceId !== ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE
                );
              } else {
                // 整備サービス または 鈑金サービスが有効でない場合は、「ローン」タブのみ
                this.tabOptions = newTabOptionsLoanExternallink;
              }
            } else {
              // 外部連携・単独申込では「ローン」タブのみ
              this.tabOptions = newTabOptionsLoanExternallink;
            }
          } else {
            // ローン申込外部連携サービス、ローン申込JOCAR連携サービス、ローン申込単独利用サービスが有効でない場合は「ローン」を除く
            this.tabOptions =
              _filter(this.tabOptions, tabOption =>
                tabOption.serviceId !== ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK
                && tabOption.serviceId !== ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR
                && tabOption.serviceId !== ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE
              );
          }

          if (!availabilities.includes(ContractConst.SERVICEID_OPT_CMN_PURCHASE_MAINTENANCE_REPAIR)) {
            /* [MASLIPMOD2-2983]
             * 2023年6月リリースまでは「サービスID 仕入サービス（整備・鈑金）」が無効なときは「仕入在庫」、「出金支払」タブを表示しない
             */
            this.tabOptions =
              _filter(this.tabOptions, tabOption =>
                (tabOption.tabId !== BusinessMenuGroupId.PurchaseTab.toString() &&
                  tabOption.serviceId !== ContractConst.SERVICEID_OPT_CMN_PURCHASE_MAINTENANCE_REPAIR) &&
                (tabOption.tabId !== BusinessMenuGroupId.DebtTabRepair.toString() &&
                  tabOption.serviceId !== ContractConst.SERVICEID_OPT_CMN_PURCHASE_MAINTENANCE_REPAIR)
              );
          }

          // タジマサービス有効判定
          this.isAvailableTajima = availabilities.includes(ContractConst.SERVICEID_OPT_CMN_TAJIMA);

          // BIツール連携サービス
          this._isAvailableBiTool = availabilities.includes(ContractConst.SERVICEID_OPT_CMN_BI_TOOL);
          this._isAvailableBiToolPm = availabilities.includes(ContractConst.SERVICEID_OPT_PMC_BI_TOOL_SALESPERFORMANCE) ||
            availabilities.includes(ContractConst.SERVICEID_OPT_PMC_BI_TOOL_STOCKPERFORMANCE);
          this._isAvailableService[ContractConst.SERVICEID_PRODUCT_PARTSMAN] =
            availabilities.includes(ContractConst.SERVICEID_PRODUCT_PARTSMAN);

          // 電帳Dx顧客連携可否
          const isElectronicBookTransfer =
            (availabilities.includes(ContractConst.SERVICEID_PRODUCT_MAINTENANCE) ||
              availabilities.includes(ContractConst.SERVICEID_PRODUCT_REPAIR) ||
              availabilities.includes(ContractConst.SERVICEID_PRODUCT_GLASS) ||
              availabilities.includes(ContractConst.SERVICEID_PRODUCT_PARTSMAN) ||
              availabilities.includes(ContractConst.SERVICEID_PRODUCT_RECYCLE)) &&
            availabilities.includes(ContractConst.SERVICEID_PRODUCT_ELECTRONIC_BOOK_DX);
          if (isElectronicBookTransfer) {
            this.pageService.sendCustomerInfoToElectronicBookDx();
          }

          // Yahoo連携
          this.relationYahoo = availabilities.includes(ContractConst.SERVICEID_OPT_RECYCLE_RELATION_YAHOO);

          // 受注メモ自動印刷
          if (availabilities.includes(ContractConst.SERVICEID_PRODUCT_RECYCLE)) {
            this.recycleOrderMemoAutoPrint();
          }

          // 未手配アラート通知
          this.pageService.notArrangedNotice(availabilities);

          _defer(() => {
            // 初期フォーカス
            this.focusFirst();
          });

          return { loginUserEmployeeBindModel, productCode };
        }),
        switchMap(({ loginUserEmployeeBindModel, productCode }) => {
          if (!this.isAvailableTajima) {
            return ObservableOf({ loginUserEmployeeBindModel, productCode });
          }

          // 一新多助メニュー設定から一新多助メニュー表示データを作成
          return this.isshinTasukeMenuService.getIsshinTasukeMenuSetting(loginUserEmployeeBindModel.blUserId!).pipe(
            tap(setting => {
              this._dispIsshinTasukeMenuData = this.isshinTasukeMenuService.createIsshinTasukeMenuData(
                setting,
                this.bizMenuGroup,
                this.isPermissionMaintenance(),
                this.isPermissionCarsales(),
                this.isPermissionRepair(),
                this.availableServiceList,
                this.permissionList
              );

              // 業務グループリストを作成
              this.businessGroupList = this.isshinTasukeMenuService.getBusinessGroupList(this.tabOptions);
              // 全業務メニューリストを作成
              this.businessAllMenuList = this.isshinTasukeMenuService.getBusinessAllMenuList(this.bizMenuGroup, this.tabOptions);

              // タブオプションをバックアップ
              this.tabOptionsBackup = _cloneDeep(this.tabOptions);

              // タブオプション設定
              this.setIsshinTasukeTabOption(setting);
            }),
            map(() => ({ loginUserEmployeeBindModel, productCode })),
          );
        }),
        mergeMap(({ loginUserEmployeeBindModel, productCode }) => {
          const organizationCode = loginUserEmployeeBindModel.organizationCode;
          return this.eventIds$(productCode, organizationCode);
        }),
      )
      .subscribe(eventIds => {
        this.eventIds = eventIds;
        this.initializedSubject.next(true);
        this.pageService.mergeAirisInquiryResultData().subscribe();
      });

    this.subscriptions.push(subscription);

    // 有効なOEMカスタマイズ情報があれば取得
    this.pageService.getAvailableOemCustomize().subscribe(
      oemCustomize => {
        this.oemCustomize = oemCustomize;
        this.setOemCustomizeStyle();
        this.initFunctions();
      }
    );
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      RxFromEvent(window, 'resize').subscribe(
        () => {
          this.showNavTabsAccordionContent();
        }
      )
    );
    _defer(() => {
      // 初期フォーカス
      this.focusFirst();
    });
  }

  /**
   * 破棄
   */
  ngOnDestroy(): void {
    _forEach(this.timer, timer => {
      clearTimeout(timer);
    });
    _forEach(this.subscriptions, subscription => {
      if (!_isNil(subscription) && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }

  /**
   * タブnav項目表示切替クリックイベントハンドラ
   */
  onClickNavTabsExpand() {
    this._isHideTabNavItem = !this._isHideTabNavItem;
  }

  /**
   * 画面遷移処理（新規タブ）
   * @param menu
   */
  onNext(menu: BizMenuContentEx) {
    let urlStream = ObservableOf(menu.urlList[0]);
    if (menu.urlList.length > 1 && !_isNil(menu.count)) {
      // 件数を表示するメニューの場合は、対象のデータがあるかないかで遷移先が変わる
      urlStream = urlStream.pipe(
        map(() => {
          const hasBadgeData =
            (!_isNil(this.existBadge[menu.count.key]) && this.existBadge[menu.count.key][menu.count.value] !== false) ||
            (!_isNil(this.nsBadge[menu.count.key]) && this.nsBadge[menu.count.key][menu.count.value] !== false);
          return hasBadgeData ? menu.urlList[1] : menu.urlList[0];
        })
      );
      // 最終案内取得キーが指定されている場合はローカルストレージから最後に開いたご案内画面を取得する
    } else if (!_isNil(menu.finalGuidanceKey)) {
      urlStream = urlStream.pipe(
        map(() => {
          const finalGuidance = LocalStorageUtils.get(menu.finalGuidanceKey) as string;
          if (finalGuidance === PageId.CallList) {
            const query = new BlUrlQuery(
              convertToParamMap({ [BlUrlQueryKey.ProductCode]: menu.productCode })
            );
            return `${Const.SpaRoot.MENU}${PagePath.CallListPage}?${query.getQueryString()}`;
          }
          return menu.urlList[0];
        })
      );
    }
    // urlListが1件より多い
    if (menu.urlList.length > 1) {
      // 一新多助メニュータブ
      if (_isEqual(this.currentTab.productCode, ContractConst.SERVICEID_OPT_CMN_TAJIMA)) {
        // サービスIDが入金の場合、ローカルストレージの入金画面タイプを元に遷移先を変える。
        if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_CMN_CREDIT)) {
          const depositScreenType: string = this.pageService.loadLocalStorageDepositScreenType();
          urlStream = urlStream.pipe(
            switchMap(() => {
              // ローカルストレージの入金画面タイプが伝票消込型の場合、menu.urlList[1]
              if (_isEqual(depositScreenType, DepositScreenType.SlipAllocation.code)) {
                return ObservableOf(menu.urlList[1]);
              } else {
                return this.pageService.getBillSetting(this.organizationCode).pipe(
                  map(setting => {
                    let newUrl = menu.urlList[0];
                    if (setting.subjects && setting.subjects.sf) {
                      if (_isEqual(DepositUrlLinkDiv.Deposit, setting.subjects.sf.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[1];
                      } else if (menu.urlList.length > 2
                        && _isEqual(DepositUrlLinkDiv.DepositCleaning, setting.subjects.sf.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[2];
                      }
                    } else if (setting.subjects && setting.subjects.repair) {
                      if (_isEqual(DepositUrlLinkDiv.Deposit, setting.subjects.repair.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[1];
                      } else if (menu.urlList.length > 2 &&
                        _isEqual(DepositUrlLinkDiv.DepositCleaning, setting.subjects.repair.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[2];
                      }
                    } else if (setting.subjects && setting.subjects.carsales) {
                      // 入金の場合
                      if (menu.urlList.length > 2 && _isEqual(DepositUrlLinkDiv.Deposit, setting.subjects.carsales.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[2];
                        // 入金消込の場合
                      } else if (menu.urlList.length > 3 &&
                        _isEqual(DepositUrlLinkDiv.DepositCleaning, setting.subjects.carsales.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[3];
                      }
                    }
                    return newUrl;
                  })
                );
              }
            })
          );
        // サービスIDが出金の場合、ローカルストレージの出金画面タイプを元に遷移先を変える。
        } else if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_CMN_CARSALES_PURCHASE)) {
          urlStream = urlStream.pipe(
            map(() => {
              const paymentScreenType: string = this.pageService.loadLocalStoragePaymentScreenType();
              return _isEqual(paymentScreenType, PaymentScreenType.SlipAllocation.code)
                ? menu.urlList[1]
                : menu.urlList[0];
            })
          );
        } else if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_MAC_RECEPTION_MGT)) {
            // サービスIDが受付管理の場合(受付アイコン押下の場合)
            urlStream = urlStream.pipe(
              switchMap(() => {
                return this.loginResourceService.getAllServiceAvailabilityInfo().pipe(
                  map((response) => {
                    const availableServiceIds = _compact(_map(response, (availability) => availability.serviceId));
                    const hasRequiredServices = _every(RECEPTION_ROUTE_SERVICE_IDS, (id) => availableServiceIds.includes(id));

                    // 顧客管理・車両管理の双方がある場合は顧客車両検索、それ以外は受付一覧へ遷移
                    return hasRequiredServices ? menu.urlList[0] : menu.urlList[1];
                  })
                );
              })
            );
          }
      // 車販タブ
      } else if (_isEqual(this.currentTab.productCode, ProductCode.CarSales)) {
        // サービスIDが入金の場合、ローカルストレージの入金画面タイプを元に遷移先を変える。
        if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_CMN_CREDIT)) {
          const depositScreenType: string = this.pageService.loadLocalStorageDepositScreenType();
          urlStream = urlStream.pipe(
            switchMap(() => {
              // ローカルストレージの入金画面タイプが伝票消込型の場合、menu.urlList[1]
              if (_isEqual(depositScreenType, DepositScreenType.SlipAllocation.code)) {
                return ObservableOf(menu.urlList[1]);
              } else {
                // 全体初期値設定
                return this.pageService.getBillSetting(this.organizationCode).pipe(
                  map(setting => {
                    let newUrl = menu.urlList[0];
                    if (setting.subjects && setting.subjects.carsales) {
                      // 入金の場合
                      if (menu.urlList.length > 2 && _isEqual(DepositUrlLinkDiv.Deposit, setting.subjects.carsales.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[2];
                        // 入金消込の場合
                      } else if (menu.urlList.length > 3 &&
                        _isEqual(DepositUrlLinkDiv.DepositCleaning, setting.subjects.carsales.depositUrlLinkDiv)) {
                        newUrl = menu.urlList[3];
                      }
                    }
                    return newUrl;
                  })
                );
              }
            })
          );
        }
        // サービスIDが出金の場合、ローカルストレージの出金画面タイプを元に遷移先を変える。
        if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_CMN_CARSALES_PURCHASE)) {
          urlStream = urlStream.pipe(
            map(() => {
              const paymentScreenType: string = this.pageService.loadLocalStoragePaymentScreenType();
              return _isEqual(paymentScreenType, PaymentScreenType.SlipAllocation.code)
                ? menu.urlList[1]
                : menu.urlList[0];
            })
          );
        }
        // 整備、鈑金、入金タブ
      } else if (_isEqual(this.currentTab.productCode, ProductCode.SuperFrontman)
        || _isEqual(this.currentTab.productCode, ProductCode.Repair)
        || _isEqual(this.currentTab.menuGroup.businessMenuGroupId, BusinessMenuGroupId.CreditTab)) {
        if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_CMN_CREDIT)) {
          urlStream = urlStream.pipe(
            switchMap(() => {
              return this.pageService.getBillSetting(this.organizationCode).pipe(
                map(setting => {
                  let newUrl = menu.urlList[0];
                  if (setting.subjects && setting.subjects.sf) {
                    if (_isEqual(DepositUrlLinkDiv.Deposit, setting.subjects.sf.depositUrlLinkDiv)) {
                      newUrl = menu.urlList[1];
                    } else if (menu.urlList.length > 2
                      && _isEqual(DepositUrlLinkDiv.DepositCleaning, setting.subjects.sf.depositUrlLinkDiv)) {
                      newUrl = menu.urlList[2];
                    }
                  } else if (setting.subjects && setting.subjects.repair) {
                    if (_isEqual(DepositUrlLinkDiv.Deposit, setting.subjects.repair.depositUrlLinkDiv)) {
                      newUrl = menu.urlList[1];
                    } else if (menu.urlList.length > 2 &&
                      _isEqual(DepositUrlLinkDiv.DepositCleaning, setting.subjects.repair.depositUrlLinkDiv)) {
                      newUrl = menu.urlList[2];
                    }
                  }
                  return newUrl;
                })
              );
            })
          );
        }
        // 鈑金タブ
        if (_isEqual(this.currentTab.productCode, ProductCode.Repair)) {
          if (_isEqual(menu.serviceId, ContractConst.SERVICEID_OPT_MAC_RECEPTION_MGT)) {
            // サービスIDが受付管理の場合(受付アイコン押下の場合)
            urlStream = urlStream.pipe(
              switchMap(() => {
                return this.loginResourceService.getAllServiceAvailabilityInfo().pipe(
                  map((response) => {
                    const availableServiceIds = _compact(_map(response, (availability) => availability.serviceId));
                    const hasRequiredServices = _every(RECEPTION_ROUTE_SERVICE_IDS, (id) => availableServiceIds.includes(id));

                    // 顧客管理・車両管理の双方がある場合は顧客車両検索、それ以外は受付一覧へ遷移
                    return hasRequiredServices ? menu.urlList[0] : menu.urlList[1];
                  })
                );
              })
            );
          }
        }
      }
    } else {
      // 物流PFタブの場合
      if (_isEqual(this.currentTab.productCode, ProductCode.DeliveryPf)) {
        // 配送管理の場合、environmentから遷移先を取得
        if (menu.businessMenuContentId === 1) {
          urlStream = urlStream.pipe(
            map(() => {
              return this.appContext.environment.deliveryPfManageUrl;
            })
          );

        }
      }
    }

    urlStream.subscribe(url => {
      // 現在のタブ情報に基づき、遷移先のURLを構築する
      // ※一新多助タブ経由の場合、currentTabは一新多助タブ自体でプロダクトを判別できないため、
      //   メニュー自体が保持するプロダクトコードを優先する
      url = this.getTargetUrl(menu.productCode || this.currentTab.productCode, this.screenActionSetting, url, menu);

      // 遷移先がAB売上連携手動送信画面の場合
      if (url === '/pm/ab-sales-connect-manual-send') {
        const data: TransitionConciergeModalRequest = {
          title: '表示する売上データ連携を選択してください。',
          settings: [
            { type: TransitionType.AbSalesConnectManualSend },
            { type: TransitionType.WcSalesConnectManualSend },
            { type: TransitionType.YhSalesLinkageInfoExport },
            { type: TransitionType.AbSalesLinkageSendLog },
            { type: TransitionType.WcSalesLinkageSendLog },
          ],
          canCloseModal: true
        };
        this.modalService.show(TransitionConciergeModalComponent, { data }).subscribe(
          modalRef => {
            // 画面を閉じる
            modalRef.hide();
            const transitionType: TransitionType = modalRef.getResults();
            if (modalRef.reason === ModalReason.Done) {
              switch (transitionType) {
                case TransitionType.AbSalesConnectManualSend:
                  break;
                case TransitionType.WcSalesConnectManualSend:
                  url = '/pm/wc-sales-connect-manual-send';
                  break;
                case TransitionType.YhSalesLinkageInfoExport:
                  url = '/pm/yh-sales-linkage-info-export';
                  break;
                case TransitionType.AbSalesLinkageSendLog:
                  url = '/pm/ab-sales-linkage-send-log';
                  break;
                case TransitionType.WcSalesLinkageSendLog:
                  url = '/pm/wc-sales-linkage-send-log';
                  break;
              }
            } else {
              url = '';
            }
            if (url !== '') {
              this.openWindow(url);
            }
          }
        );
        // 遷移先が各種確認表の場合
      } else if (url === '/pm/ledger-sheet/confirm-linkage') {
        const data: TransitionConciergeModalRequest = {
          title: '表示する各種確認表を選択してください。',
          settings: [
            { type: TransitionType.EstimateConfirmation },  // 見積確認表
            { type: TransitionType.OrderConfirm },   // 受注貸出確認
            { type: TransitionType.SalesConfirmation },   // 売上確認表
            { type: TransitionType.StockMoveConfirmation },  // 移動確認表
            { type: TransitionType.StockAdjustConfirmList }, // 調整確認表
            { type: TransitionType.PurchaseConfirmationList }, // 仕入確認表
            { type: TransitionType.StockReceivingShippingConfirmation },  // 入出庫確認表
          ],
          canCloseModal: true
        };
        this.modalService.show(TransitionConciergeModalComponent, { data }).subscribe(
          modalRef => {
            // 画面を閉じる
            modalRef.hide();
            const transitionType: TransitionType = modalRef.getResults();
            if (modalRef.reason === ModalReason.Done) {
              switch (transitionType) {
                case TransitionType.EstimateConfirmation:
                  url = '/pm/ledger-sheet/estimate-confirmation-list';
                  break;
                case TransitionType.OrderConfirm:
                  url = '/pm/ledger-sheet/order-loan-confirmation';
                  break;
                case TransitionType.SalesConfirmation:
                  url = '/pm/ledger-sheet/sales-confirmation-list';
                  break;
                case TransitionType.StockMoveConfirmation:
                  url = '/pm/stock-control/stock-move-confirmation-list';
                  break;
                case TransitionType.StockAdjustConfirmList:
                  url = '/pm/stock-control/stock-adjust-confirmation-list';
                  break;
                case TransitionType.PurchaseConfirmationList:
                  url = '/pm/ledger-sheet/purchase-confirmation-list';
                  break;
                case TransitionType.StockReceivingShippingConfirmation:
                  url = '/pm/stock-control/stock-receiving-shipping-confirmation';
                  break;
              }
            } else {
              url = '';
            }
            if (url !== '') {
              this.openWindow(url);
            }
          }
        );
        // 遷移先が重点品目の場合
      } else if (url === '/pm/ledger-sheet/important-item-linkage') {
        const data: TransitionConciergeModalRequest = {
          title: '重点品目画面を選択してください。',
          settings: [
            { type: TransitionType.ImportantItemInquiry },  // 重点品目実績表
            { type: TransitionType.ImportantItemTransition },   // 重点品目推移表
          ],
          canCloseModal: true
        };
        this.modalService.show(TransitionConciergeModalComponent, { data }).subscribe(
          modalRef => {
            // 画面を閉じる
            modalRef.hide();
            const transitionType: TransitionType = modalRef.getResults();
            if (modalRef.reason === ModalReason.Done) {
              switch (transitionType) {
                case TransitionType.ImportantItemInquiry:
                  url = '/pmsales/imp-item-mng-perf-inquiry';
                  break;
                case TransitionType.ImportantItemTransition:
                  url = '/pmsales/imp-item-mng-perf-transition';
                  break;
              }
            } else {
              url = '';
            }
            if (url !== '') {
              this.openWindow(url);
            }
          }
        );

      } else if (
        (
          this.isPartsOrderTab(this.currentTab.menuGroup) &&
          (
            menu.businessMenuContentId === BlPartsOrderMenuContentId.PayConfirm ||
            menu.businessMenuContentId === BlPartsOrderMenuContentId.Cart
          )
        ) ||
        (
          this.currentTabId === MaintenanceTabId.IsshinTasuke &&
          menu.serviceId === ContractConst.SERVICEID_OPT_CMN_CONTACT_ORDER_USEDPART &&
          (
            menu.businessMenuContentId === BlPartsOrderMenuContentId.PayConfirm ||
            menu.businessMenuContentId === BlPartsOrderMenuContentId.Cart
          )
        )
      ) {
        // MEMO タブID(businessMenuGroupId)が受発注とリサイクルで同じ値になってしまっているらしいのでタブ判定の条件として採用しない
        if (this.hasPsUserCode) {
          this.openWindow(url);
        } else {
          const element = document.activeElement;
          this.dialogService.custom(
            'ご利用には、BL回収代行サービスのお申込みが必要です',
            {
              title: '確認',
              icon: DialogIcon.Question,
              color: DialogColor.Info,
              buttonType: ModalButtonType.OkCancel,
              buttonSetting: {
                ok: { label: '申し込む', color: ModalButtonColor.Success },
                cancel: { label: 'キャンセル', color: ModalButtonColor.None },
                any: {},
              }
            }
          ).subscribe(
            dialogRef => {
              dialogRef.hide(element);
              if (dialogRef.reason === ModalReason.Done) {
                window.open('https://sfc.blcloud.jp/support/sf/application', '_blank');
              }
            }
          );
        }
        // 遷移先が実績照会画面の場合
      } else if (url === '/pm/sales-bulletin-display') {
        this.performanceInquiryShow(url);
      } else {
        this.openWindow(url);
      }
    });
  }

  /**
   * 遷移先が実績照会画面の画面表示
   * @param url 遷移先URI
   */
  private performanceInquiryShow(url: string) {
    const data: TransitionConciergeModalRequest = {
      title: '確認する照会画面を選択してください。',
      settings: [
        { type: TransitionType.SalesBulletinDisplay },
        { type: TransitionType.PicEmployeePerformanceInquiry },
        { type: TransitionType.ShippingGoodsInquiry },
        { type: TransitionType.CustomerPreviousPerformanceInquiry },
        { type: TransitionType.PurchaseYearPerformanceInquiry },
      ],
      canCloseModal: true
    };
    this.modalService.show(TransitionConciergeModalComponent, { data }).subscribe(
      modalRef => {
        // 画面を閉じる
        modalRef.hide();
        const transitionType: TransitionType = modalRef.getResults();
        if (modalRef.reason === ModalReason.Done) {
          switch (transitionType) {
            case TransitionType.SalesBulletinDisplay:
              break;
            case TransitionType.PicEmployeePerformanceInquiry:
              url = '/pm/pic-employee-performance-inquiry';
              break;
            case TransitionType.ShippingGoodsInquiry:
              url = '/pm/shipping-goods-inquiry';
              break;
            case TransitionType.CustomerPreviousPerformanceInquiry:
              url = '/pm/customer-previous-performance-inquiry';
              break;
            case TransitionType.PurchaseYearPerformanceInquiry:
              url = '/pm/purchase-year-performance-inquiry';
              break;
            default:
              break;
          }
        } else {
          url = '';
        }
        if (url !== '') {
          this.openWindow(url);
        }
      }
    );
  }

  /**
   * バッジデータの初期化
   */
  private clearBadge() {
    _forEach(SfSlipKindArray, sfSlipKind => {
      this.badge.sfSlip[sfSlipKind.value] = {
        final: 0,
        draft: 0,
      };
      this.existBadge.sfSlip[sfSlipKind.value] = null;
      this.nsBadge.sfSlip[sfSlipKind.value] = null;
    });
    // 入金
    this.badge.deposit[SlipKind.EstimatesSlip] = {
      final: 0,
      draft: 0,
    };
    this.existBadge.deposit[SlipKind.EstimatesSlip] = null;
    for (const slipKind of SlipKindArray) {
      this.badge.repairSlip[slipKind.value] = {
        final: 0,
        draft: 0,
      };
      this.existBadge.repairSlip[slipKind.value] = null;
    }
    _forEach(CsSlipKindArray, csSlipKind => {
      this.badge.csSlip[csSlipKind.value] = {
        final: 0,
        draft: 0,
      };
      this.existBadge.csSlip[csSlipKind.value] = null;
    });
    // 仕入伝票
    this.badge.purchaseSlip['purchaseSlip'] = {
      final: 0,
      draft: 0,
    };
    this.existBadge.purchaseSlip['purchaseSlip'] = null;
    // 払出移動伝票
    this.badge.payoutMoveSlip['payoutMoveSlip'] = {
      final: 0,
      draft: 0,
    };
    this.existBadge.payoutMoveSlip['payoutMoveSlip'] = null;
    // BLPay
    this.badge.blPayAffiliated['affiliatedStoreOrderList'] = {
      final: 0,
      draft: 0
    };
    this.badge.blPaySuppliers['suppliersOrderList'] = {
      final: 0,
      draft: 0
    };
    // 使わないので常にtrue
    this.existBadge.blPayAffiliated['affiliatedStoreOrderList'] = true;
    this.existBadge.blPaySuppliers['suppliersOrderList'] = true;

    this.badge.partsOrder = {
      mpCart: { final: 0, draft: 0 },
      mpFavorite: { final: 0, draft: 0 },
      inquiryPartsChat: { final: -1, draft: -1 },
    };

    // 共有車両在庫（final=要対応(赤)／draft=進行中・下書き(青)。使わない枠は-1で非表示）
    this.badge.sharedVehicleStock = {
      transManage: { final: 0, draft: 0 },
      payment: { final: 0, draft: -1 },
      stockRegist: { final: -1, draft: 0 },
      consideration: { final: 0, draft: -1 },
    };
    // 「未登録」文言は共有車両在庫では使用しないため常にtrue
    this.existBadge.sharedVehicleStock = {
      transManage: true,
      payment: true,
      stockRegist: true,
      consideration: true,
    };
  }

  /**
   * 入金 バッジデータの初期化
   */
  private clearDepositBadge() {
    // 入金
    this.badge.deposit[SlipKind.EstimatesSlip] = {
      final: 0,
      draft: 0,
    };
    this.existBadge.deposit[SlipKind.EstimatesSlip] = null;
  }


  /**
   * 受発注 バッジデータの初期化
   */
  private clearPartsOrderBadge() {
    this.badge.partsOrder = {
      mpCart: { final: 0, draft: 0 },
      mpFavorite: { final: 0, draft: 0 },
      inquiryPartsChat: { final: -1, draft: -1 },
    };
    this.existBadge.partsOrder = {
      mpCart: null,
      mpFavorite: null,
      inquiryPartsChat: true,
    };
  }

  /**
   * sfのバッジデータ
   */
  private get sfSlipCountMgt$() {
    const conditions = new BlApiSearchCondition();

    // 伝票種別、ログインユーザの所属組織コードで抽出
    _forEach(SfSlipKindArray, sfSlipKind => {
      conditions.addCondition(
        BlApiConditionHelper.makeCondAnd(
          BlApiConditionHelper.makeCondStrEqual('sfSlipKind', sfSlipKind.value),
          BlApiConditionHelper.makeCondStrEqual('slipMgtStdOrgCode', this.organizationCode),
        )
      );
    });

    return this.sfSlipCountMgtResource.getAll<ISfSlipCountMgt>({ conditions });
  }

  /**
   * 入金のバッジデータ
   */
  private get depositCount$() {
    const getBadges$: Observable<ISfSlipCountMgt>[] = [];

    return this.pageService.fetchProductCodeListByServiceId().pipe(
      mergeMap((productCodeList: string[]) => {
        const productCode = productCodeList.shift();

        // 優先度の高いプロダクトの件数を取得する
        getBadges$.push(this.getDepositCountWithProductCode(productCode));

        // 同居対応の1次対応として部品商とリサイクルが同居している場合、両プロダクトの件数を取得する
        if (productCode === ProductCode.Partsman) {
          const recycle = _find(productCodeList, code => code === ProductCode.Recycle);
          if (!_isNil(recycle)) {
            getBadges$.push(this.getDepositCountWithProductCode(ProductCode.Recycle));
          }
        }
        // 整備・鈑金・車販・部品商と硝子は文字を非表示
        if (productCode === ProductCode.SuperFrontman || productCode === ProductCode.CarSales
          || productCode === ProductCode.Partsman || productCode === ProductCode.Glass
        ) {
          this.existBadge.deposit[SlipKind.EstimatesSlip] = true;
          this._isDepositMessageDisp = false;
        }

        return ObservableForkJoin(getBadges$).pipe(
          map((responses) => {
            const result = responses.shift() || { commitSlipCount: 0, draftSlipCount: 0 };

            // 確定伝票件数と下書き伝票件数をサマリ
            _forEach(responses, response => {
              if (_isNil(response)) {
                return;
              }
              result.commitSlipCount += response.commitSlipCount;
              result.draftSlipCount += response.draftSlipCount;
            });

            return result;
          })
        );
      })
    );
  }

  /**
   * 指定されたプロダクトの入金のバッジデータ取得
   */
  private getDepositCountWithProductCode(productCode: string) {
    const params = new BlApiQueryParams();
    const conditions = new BlApiSearchCondition();

    conditions.addCondition(
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('productCode', productCode),
        BlApiConditionHelper.makeCondStrEqual('depositSlipMgtOrgCode', this.organizationCode),
      )
    );

    params.setCondition(conditions);
    return this.depositListSearchConditionResource.get<ISfSlipCountMgt>(
      {
        params,
        entityOptions: {
          operation: 'depositsearchlist',
          exPath: 'search_count',
        }
      }
    );
  }

  /**
   * 車販のバッジデータ
   */
  private get carsalseCount$() {
    const conditions = new BlApiSearchCondition();

    // 伝票種別、ログインユーザの所属組織コードで抽出
    _forEach(CsSlipKindArray, csSlipKind => {
      conditions.addCondition(
        BlApiConditionHelper.makeCondAnd(
          BlApiConditionHelper.makeCondStrEqual('csSlipKind', csSlipKind.value),
          BlApiConditionHelper.makeCondStrEqual('slipMgtStdOrgCode', this.organizationCode),
        )
      );
    });

    return this.csSlipCountMgtResource.getAll<ICsSlipCountMgt>({ conditions });
  }

  /**
   * sfのバッジデータ取得
   */
  getSfSlipCount() {
    // 整備伝票件数取得可能フラグを取得し、取得可能の場合に件数取得APIを呼び出す
    this.pageService.getCommonGenericFlagMgt(this.COUNT_BADGE_ALLOW_FLAG_KEY).subscribe(
      flag => {
        if (flag) {
          this.sfSlipCountMgt$.subscribe(
            (response) => {
              _forEach(SfSlipKindArray, sfSlipKind => {
                const sfSlipCount = _find(response.searchResultList, val => val && val.sfSlipKind === sfSlipKind.value);
                if (_isNil(sfSlipCount)) {
                  return;
                }
                this.badge.sfSlip[sfSlipKind.value] = {
                  final: sfSlipCount.commitSlipCount,
                  draft: sfSlipCount.draftSlipCount,
                };

                this.existBadge.sfSlip[sfSlipKind.value] =
                  sfSlipCount.commitSlipCount > 0 || sfSlipCount.draftSlipCount > 0;

                this.nsBadge.sfSlip[sfSlipKind.value] = sfSlipCount.nsNoReceiveSlipCount > 0;
              });
            },
            () => {
            },
            () => {
              if (this.timer.sfSlip) {
                clearTimeout(this.timer.sfSlip);
              }
              // TODO: 一時的にタイマー廃止
              // this.timer.sfSlip = setTimeout(() => {
              //   this.getSfSlipCount();
              // }, this.badgeInterval);
            }
          );
        }
      }
    );
  }

  /**
   * 入金のバッジデータ取得
   */
  getDepositCount() {
    this.depositCount$
      .subscribe(
        (response) => {
          this.badge.deposit[SlipKind.EstimatesSlip] = {
            final: response.commitSlipCount,
            draft: response.draftSlipCount,
          };
          if (this._isDepositMessageDisp) {
            this.existBadge.deposit[SlipKind.EstimatesSlip] = response.draftSlipCount > 0;
          }
        },
        () => {
        },
        () => {
          if (this.timer.deposit) {
            clearTimeout(this.timer.deposit);
          }
          this.timer.deposit = setTimeout(() => {
            this.getDepositCount();
          }, this.badgeInterval);
        });
  }

  /**
   * 出金のバッジデータ取得
   */
  getPaymentCount() {
    this.paymentCount$
      .subscribe(
        (totalCount) => {
          this.badge.deposit[SlipKind.EstimatesSlip] = {
            // 確定は非表示にするため設定しない
            draft: totalCount,
          };
          if (this._isPaymentMessageDisp) {
            this.existBadge.deposit[SlipKind.EstimatesSlip] = totalCount > 0;
          }
        },
        () => {
        },
        () => {
          if (this.timer.deposit) {
            clearTimeout(this.timer.deposit);
          }
          this.timer.deposit = setTimeout(() => {
            this.getPaymentCount();
          }, this.badgeInterval);
        }
      );
  }

  /**
   * 受注売上のバッジデータ
   */
  private get orderSalesCount$() {
    const getBadges$: Observable<any>[] = [];

    getBadges$.push(this.pageService.glassSlipDraftCount(SlipKind.SalesOrderSlip));
    getBadges$.push(this.pageService.glassSlipDraftCount(SlipKind.SalesSlip));

    return ObservableForkJoin(getBadges$).pipe(
      map((responses) => {
        let totalCount = 0;
        _forEach(responses, response => {
          totalCount += response.totalCount;
        });
        return totalCount;
      })
    );
  }

  getRepairBadge() {
    this.repairSlipQuantityManageResource.get().subscribe((rs: IRepairSlipQuantityManage) => {
      if (_isNil(rs)) {
        return;
      }
      this.badge.repairSlip[SlipKind.EstimatesSlip] = {
        final: rs.estimatesSlipQuantity,
        draft: rs.estimatesSlipDraftQuantity
      };
      this.badge.repairSlip[SlipKind.SalesOrderSlip] = {
        final: rs.salesOrderQuantity,
        draft: rs.salesOrderDraftQuantity
      };
      this.badge.repairSlip[SlipKind.SalesSlip] = { final: rs.salesSlipQuantity, draft: rs.salesSlipDraftQuantity };
      this.existBadge.repairSlip[SlipKind.EstimatesSlip] = (rs.estimatesSlipQuantity > 0 || rs.estimatesSlipDraftQuantity > 0);
      this.existBadge.repairSlip[SlipKind.SalesOrderSlip] = (rs.salesOrderQuantity > 0 || rs.salesOrderDraftQuantity > 0);
      this.existBadge.repairSlip[SlipKind.SalesSlip] = (rs.salesSlipQuantity > 0 || rs.salesSlipDraftQuantity > 0);
    }, () => {
      // エラーが出ても握りつぶす
    }, () => {
      if (this.timer.repair) { // すでに実行中であれば解除する
        clearTimeout(this.timer.repair);
      }
      this.timer.repair = setTimeout(() => {
        this.getRepairBadge();
      }, this.badgeInterval);
    });
  }

  /**
   * BLPay(加盟店)のバッジデータを取得
   */
  getBlPayAffiliatedCount() {
    this.pageService.getBlPayAffiliatedCount(this.contractInquiryId).subscribe((count) => {
      this.badge.blPaySuppliers['suppliersOrderList'] = {
        final: count,
        draft: count
      };

    }, () => {
      // エラーが出ても握りつぶす
    }, () => {
      if (this.timer.blPaySuppliers) { // すでに実行中であれば解除する
        clearTimeout(this.timer.blPaySuppliers);
      }
      this.timer.blPaySuppliers = setTimeout(() => {
        this.getBlPayAffiliatedCount();
      }, this.badgeInterval);
    });
  }

  /**
   * BLPay(取引先)のバッジデータを取得
   */
  getBlPaySuppliersCount() {
    this.pageService.getBlPaySuppliersCount(this.contractInquiryId).subscribe((count) => {
      this.badge.blPayAffiliated['affiliatedStoreOrderList'] = {
        final: count,
        draft: count
      };
    }, () => {
      // エラーが出ても握りつぶす
    }, () => {
      if (this.timer.blPayAffiliated) { // すでに実行中であれば解除する
        clearTimeout(this.timer.blPayAffiliated);
      }
      this.timer.blPayAffiliated = setTimeout(() => {
        this.getBlPaySuppliersCount();
      }, this.badgeInterval);
    });
  }

  /**
   * Yahooの公開鍵期限切れチェック
   */
  private checkYahooPublicKeyExpired() {
    this.pageService.getYahooOrderInfoPublicKeyValidationCheck().subscribe(
      () => { },
      (error: BlApiErrorInfo) => {
        if (error.status === HttpStatus.Unauthorized) {
          // 公開鍵有効期限切れの場合、警告を表示
          const data = {
            message: error.messages[0],
          };
          this.modalService.show(YahooPublicKeyWarnModalComponent, { data }).subscribe(modalRef => {
            if (modalRef.reason === ModalReason.Done) {
              // 設定の場合、オンライン自社へジャンプ
              const urlQuery = new BlUrlQuery();
              urlQuery.setValue(BlUrlQueryKey.Menu, true);
              this.openWindow(UrlUtils.buildUrlPath('/maintenance/company/onlinecompany/externalservices', {
                params: urlQuery.getQueryParams()
              }));
            } else if (modalRef.reason === ModalReason.Any) {
              // 設定案内の場合、Yahoo公開鍵の設定動画(外部サイト)へジャンプ
              this.openWindow(UrlUtils.buildUrlPath(this.appContext.environment.yahooPublicKeySettingMovieURL, null));
            } else {
              modalRef.hide();
            }
          });
        } else {
          throw error;
        }
      },
      () => {
        if (this.timer.yahoo) {
          clearTimeout(this.timer.yahoo);
        }
        // 1時間おきにポーリング
        this.timer.yahoo = setTimeout(() => {
          this.checkYahooPublicKeyExpired();
        }, 1000 * 60 * 60);
      }
    );
  }

  /**
   * Yahooのログイン有効期限チェック
   */
  private checkYahooExpirationDate() {
    // Yahoo連携サービスID設定を取得する
    this.loadingService.show();
    this.pageService.getYahooApplicationIdSetting(this.organizationCode).subscribe((response) => {
      this.loadingService.hide();
      if (response && response.yahooRefreshTokenUpdateDateTime) {
        // 有効期限(Yahooリフレッシュトークン更新日時の28日後)より、1週間前を過ぎている場合、処理を実施
        const comparisonDate = new Date(DateTimeUtils.format(
          DateTimeUtils.addDays(DateTimeUtils.parseDate(response.yahooRefreshTokenUpdateDateTime), 21)
        ));
        const now = new Date(Date.now());
        if (comparisonDate <= now) {
          // 有効期限(Yahooリフレッシュトークン更新日時の28日後)を警告モーダルに表示
          const expirationDate = this.getExpirationDate(response.yahooRefreshTokenUpdateDateTime);
          this.modalService.show(YahooWarnModalComponent, { data: { expirationDate } }).subscribe((modalRef) => {
            modalRef.hide();
          });
        }
      }
    });
  }

  /**
   * Yahooの在庫数差異確認
   */
  private checkYahooDiffExistFlag() {
    this.loadingService.show();
    this.pageService.getYahooDiffExistFlag().subscribe(res => {
      this.loadingService.hide();
      if (res) {
        // 差異が発生している場合(ステータスが200の場合)、警告を表示する

        // ダイアログオプション(警告)
        const dialogOption: DialogOption = {
          title: '警告',
          color: DialogColor.Warning,
          icon: DialogIcon.Exclamation,
          buttonType: ModalButtonType.OkCancel,
          buttonSetting: {
            ok: { label: '出品在庫確認' },
            cancel: { label: '閉じる' },
            any: null
          },
          focus: ModalButton.Ok
        };
        this.dialogService.custom(
          'Yahoo!とRecycle+の在庫数に差異が生じている在庫があります。\n出品管理>出品在庫確認よりご確認ください。',
          dialogOption
        ).subscribe(dialogRef => {
          if (dialogRef.reason === ModalReason.Done) {
            // 別タブで出品在庫確認を表示する
            window.open(UrlUtils.buildUrlPath('/recycle/listing-stock-confirm'), '_blank');
          }
          dialogRef.hide();
        });
      }
    });
  }

  /**
   * 受注メモ自動印刷を実施する
   */
  private recycleOrderMemoAutoPrint() {
    // 印刷可能かどうかを調べる
    this.pageService.isOrderMemoAutoPrintEmployee(this.organizationCode).subscribe(res => {
      if (res) {
        this.pageService.getOrderMemoAutoPrintErrorInfo(this.organizationCode).subscribe(_res => {
          // 受注メモ自動印刷エラー情報が存在する場合、受注メモ自動印刷を実施
          if (_res) {
            this.pageService.orderMemoAutoPrint().subscribe(
              () => { },
              (error: BlApiErrorInfo) => {
                if (error.status === HttpStatus.NotFound) {
                  this.dialogService.warn(error.messages[0]).subscribe(ref => {
                    if (ref.reason === ModalReason.Done) {
                      ref.hide();
                    }
                  });
                  return;
                } else {
                  // 他のエラーは無視する
                  return ObservableOf([]);
                }
              }
            );
          }
        }, _error => {
          // エラーは無視する
          return ObservableOf([]);
        });
      }
    }, _error => {
      // エラーは無視する
      return ObservableOf([]);
    });
  }

  /**
   * リサイクルのバッジデータ取得
   */
  private getRecycleBadge(businessMenuGroupId: number) {
    const getBadges$: Observable<any>[] = [];

    // 車両受付
    const VehicleReceptionMenuContentId = 13;
    getBadges$.push(this.getRecycleBadgeItemsCount(
      this.pageService.countRecycleVehicleReception(this.organizationCode), businessMenuGroupId, VehicleReceptionMenuContentId));

    // 車両入庫
    const VehicleWarehousingMenuContentId = 2;
    getBadges$.push(this.getRecycleBadgeItemsCount(
      this.pageService.countRecycleVehicleWarehousing(this.organizationCode), businessMenuGroupId, VehicleWarehousingMenuContentId));

    // 見積依頼確認
    const EstimateRequestConfirmMenuContentId = 15;
    getBadges$.push(this.getRecycleBadgeItemsCount(
      this.pageService.countRecycleEstimateRequestConfirm(this.organizationCode, this.blTenantId),
      businessMenuGroupId,
      EstimateRequestConfirmMenuContentId));
    // バッジ取得
    ObservableForkJoin(getBadges$).subscribe(
      () => { }, () => { },
      () => {
        if (this.timer.recycle) {
          clearTimeout(this.timer.recycle);
        }
        this.timer.recycle = setTimeout(() => {
          this.getRecycleBadge(businessMenuGroupId);
        }, this.badgeInterval);
      }
    );
  }

  /**
   * リサイクルのバッジデータ取得
   */
  private getRecycleBadgeItemsCount(
    countService: Observable<number>,
    businessMenuGroupId: number,
    businessMenuContentId: number,
  ) {
    return countService
      .pipe(
        tap((count) => {
          if (_isNil(this.badge[businessMenuGroupId])) {
            this.badge[businessMenuGroupId] = {};
          }
          this.badge[businessMenuGroupId][businessMenuContentId] = {
            final: count,
            // 下書きは存在しないため設定しない
          };
          if (_isNil(this.existBadge[businessMenuGroupId])) {
            this.existBadge[businessMenuGroupId] = {};
          }
          this.existBadge[businessMenuGroupId][businessMenuContentId] = count > 0;
        }),
      );
  }

  /**
   * 出金のバッジデータ
   */
  private get paymentCount$() {
    const getBadges$: Observable<number>[] = [];

    return this.pageService.fetchProductCodeListByServiceId().pipe(
      mergeMap((productCodeList: string[]) => {
        const productCode = productCodeList.shift();

        // 優先度の高いプロダクトの件数を取得する
        getBadges$.push(this.getPaymentCountWithProductCode(productCode));

        // 同居対応の1次対応として部品商とリサイクルが同居している場合、両プロダクトの件数を取得する
        if (productCode === ProductCode.Partsman) {
          const recycle = _find(productCodeList, code => code === ProductCode.Recycle);
          if (!_isNil(recycle)) {
            getBadges$.push(this.getPaymentCountWithProductCode(ProductCode.Recycle));
          }
        }
        // 部品商は文字を非表示
        if (productCode === ProductCode.Partsman) {
          this.existBadge.deposit[SlipKind.EstimatesSlip] = true;
          this._isPaymentMessageDisp = false;
        }

        return ObservableForkJoin(getBadges$).pipe(
          map((responses) => {
            let result = responses.shift();

            // 件数をサマリ
            _forEach(responses, response => {
              result += response;
            });

            return result;
          })
        );
      })
    );
  }

  /**
   * 指定されたプロダクトの出金のバッジデータ取得
   */
  private getPaymentCountWithProductCode(productCode: string) {
    const params = new BlApiQueryParams();
    const conditions = new BlApiSearchCondition();

    conditions.addCondition(
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('productCode', productCode),
        BlApiConditionHelper.makeCondStrEqual('paySlipMgtOrgCode', this.organizationCode),
        BlApiConditionHelper.makeCondStrEqual('cutoffSettledSlipDiv', CutoffSettledSlipDiv.CutoffSettled),
      )
    );
    params.setCondition(conditions);
    return this.payListSearchConditionResource.get<{ totalCount: number }>(
      {
        params, entityOptions: { operation: 'paymentsearchlist/draft', exPath: 'search_count' }
      }
    ).pipe(
      map((res) => res.totalCount),
      catchError(() => {
        // エラーは無視する
        return ObservableOf(0);
      })
    );
  }

  /**
   * 仕入伝票のバッジデータ取得
   */
  getPurchaseSlipCount() {
    this.purchaseSlipCount$
      .subscribe(
        (counts) => {
          this.badge.purchaseSlip['purchaseSlip'] = {
            final: counts[0],
            draft: counts[1],
          };
          this.existBadge.purchaseSlip['purchaseSlip'] = counts[0] > 0 || counts[1] > 0;
        },
        () => {
        },
        () => {
          if (this.timer.purchaseSlip) {
            clearTimeout(this.timer.purchaseSlip);
          }
          this.timer.purchaseSlip = setTimeout(() => {
            this.getPurchaseSlipCount();
          }, this.badgeInterval);
        }
      );
  }

  /**
   * 仕入伝票入力のバッジデータ取得
   */
  private get purchaseSlipCount$() {
    const conditionsFixed = new BlApiSearchCondition();
    const conditionsDraft = new BlApiSearchCondition();

    conditionsFixed.addCondition(
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('draftFixedStatusDiv', DraftFixedStatusDiv.Fixed),
        BlApiConditionHelper.makeCondStrEqual('slipOrganizationCode', this.organizationCode),
        BlApiConditionHelper.makeCondStrNotEqual('productCode', ProductCode.CarSales),
      )
    );
    conditionsDraft.addCondition(
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('draftFixedStatusDiv', DraftFixedStatusDiv.Draft),
        BlApiConditionHelper.makeCondStrEqual('slipOrganizationCode', this.organizationCode),
        BlApiConditionHelper.makeCondStrNotEqual('productCode', ProductCode.CarSales),
      )
    );

    return ObservableForkJoin([
      this.purchaseSlipInfoSearchResource.search<IPurchaseSlipInfoSearch>({ conditions: conditionsFixed, size: 100 }),
      this.purchaseSlipInfoSearchResource.search<IPurchaseSlipInfoSearch>({ conditions: conditionsDraft, size: 100 })])
      .pipe(
        map(([responseFixed, responseDraft]) => {
          let countFixed = 0;
          let countDraft = 0;
          if (responseFixed && responseFixed.totalCount) {
            countFixed = responseFixed.totalCount;
          }
          if (responseDraft && responseDraft.totalCount) {
            countDraft = responseDraft.totalCount;
          }
          return [countFixed, countDraft];
        })
      );
  }

  /**
   * 払出移動伝票のバッジデータ取得
   */
  getPayoutMoveSlipCount() {
    this.payoutMoveSlipCount$
      .subscribe(
        (counts) => {
          this.badge.payoutMoveSlip['payoutMoveSlip'] = {
            final: counts[0],
            draft: counts[1],
          };
          this.existBadge.payoutMoveSlip['payoutMoveSlip'] = counts[0] > 0 || counts[1] > 0;
        },
        () => {
        },
        () => {
          if (this.timer.payoutMoveSlip) {
            clearTimeout(this.timer.payoutMoveSlip);
          }
          this.timer.payoutMoveSlip = setTimeout(() => {
            this.getPayoutMoveSlipCount();
          }, this.badgeInterval);
        }
      );
  }

  /**
   * 払出移動伝票のバッジデータ取得
   */
  private get payoutMoveSlipCount$() {
    const conditionsFixed = new BlApiSearchCondition();
    const conditionsDraft = new BlApiSearchCondition();

    conditionsFixed.addCondition(
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('draftFixedStatusDiv', DraftFixedStatusDiv.Fixed),
        BlApiConditionHelper.makeCondStrEqual('slipMgtStdOrgCode', this.organizationCode),
      )
    );
    conditionsDraft.addCondition(
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('draftFixedStatusDiv', DraftFixedStatusDiv.Draft),
        BlApiConditionHelper.makeCondStrEqual('slipMgtStdOrgCode', this.organizationCode),
      )
    );

    return ObservableForkJoin([
      this.payoutMoveSlipInfoSearchResource.search({ conditions: conditionsFixed, size: 100 }),
      this.payoutMoveSlipInfoSearchResource.search({ conditions: conditionsDraft, size: 100 })])
      .pipe(
        map(([responseFixed, responseDraft]) => {
          let countFixed = 0;
          let countDraft = 0;
          if (responseFixed && responseFixed.totalCount) {
            countFixed = responseFixed.totalCount;
          }
          if (responseDraft && responseDraft.totalCount) {
            countDraft = responseDraft.totalCount;
          }
          return [countFixed, countDraft];
        })
      );
  }

  /**
   * 車販のバッジデータ取得
   */
  getCsSlipCount() {
    this.carsalseCount$
      .subscribe(
        (response) => {
          _forEach(CsSlipKindArray, csSlipKind => {
            const csSlipCount = _find(response.searchResultList, val => val && val.csSlipKind === csSlipKind.value);
            if (_isNil(csSlipCount)) {
              return;
            }
            this.badge.csSlip[csSlipKind.value] = {
              final: csSlipCount.commitSlipCount,
              draft: csSlipCount.draftSlipCount,
            };

            this.existBadge.csSlip[csSlipKind.value] =
              csSlipCount.commitSlipCount > 0 || csSlipCount.draftSlipCount > 0;
          });
        },
        () => {
        },
        () => {
          if (this.timer.csSlip) {
            clearTimeout(this.timer.csSlip);
          }
          this.timer.csSlip = setTimeout(() => {
            this.getCsSlipCount();
          }, this.badgeInterval);
        });
  }

  /**
   * 共有車両在庫のバッジデータ
   */
  private get sharedVehicleStockCountMgt$(): Observable<ISharedVehicleStockCountMgt> {
    // ログインユーザの所属組織、取引状態＝成約／支払待ち・支払済みで抽出
    // （在庫未登録件数は抽出した範囲で集計されるため、取引状態の条件は必須）
    const conditions: BlConditionInfo[] = [
      { key: 'organizationCode', value: this.organizationCode, type: BlConditionType.Equal },
      {
        key: 'sharedVehicleStockStatus',
        value: [SharedVehicleStockStatus.Contract, SharedVehicleStockStatus.Paid],
        type: BlConditionType.In,
      },
    ];

    // L-Stock-3021 共有車両在庫取引状態件数_取得
    // 検索条件を渡すため取引一覧画面と同様に search で呼ぶ（レスポンスは BlListResponseBody ではないため型アサーション）
    return this.sharedVehicleStockTransInfoResource.search<ISharedVehicleStockCountMgt>(
      { conditions },
      { entityOptions: { exPath: 'sharedvehiclestockstatuscount' } }
    ).pipe(
      map(response => response as ISharedVehicleStockCountMgt)
    );
  }

  /**
   * 共有車両在庫のバッジデータを取得する
   */
  private getSharedVehicleStockCount() {
    this.sharedVehicleStockCountMgt$
      .subscribe(
        (response) => {
          // 成約／支払待ちの件数（取引管理・計算書・決済の赤バッジ）
          const contractCount = this.findSharedVehicleStockStatusCount(response, SharedVehicleStockStatus.Contract);
          this.badge.sharedVehicleStock.transManage.final = contractCount;
          this.badge.sharedVehicleStock.payment.final = contractCount;
          // 在庫未登録の件数（取引管理・自社在庫へ格納の青バッジ）
          // ＝成約／支払待ち・支払済みのうち車両販売管理通番が未設定の件数（取引状態の絞り込みは検索条件で行う）
          const uninventoriedCount = _isNil(response.companyStockUninventoriedCount) ? 0 : response.companyStockUninventoriedCount;
          this.badge.sharedVehicleStock.transManage.draft = uninventoriedCount;
          this.badge.sharedVehicleStock.stockRegist.draft = uninventoriedCount;
        },
        () => {
        },
        () => {
          if (this.timer.sharedVehicleStock) {
            clearTimeout(this.timer.sharedVehicleStock);
          }
          this.timer.sharedVehicleStock = setTimeout(() => {
            this.getSharedVehicleStockCount();
          }, this.badgeInterval);
        });
  }

  /**
   * 共有車両在庫件数管理レスポンスから指定した取引状態の件数を取得する
   * @param countMgt 共有車両在庫件数管理
   * @param status 共有車両在庫取引状態
   */
  private findSharedVehicleStockStatusCount(countMgt: ISharedVehicleStockCountMgt, status: string): number {
    const statusCount = _find(
      countMgt.sharedVehicleStockStatusCountMgtList,
      val => !_isNil(val) && val.sharedVehicleStockStatus === status
    );
    return _isNil(statusCount) || _isNil(statusCount.sharedVehicleStockCount) ? 0 : statusCount.sharedVehicleStockCount;
  }

  /**
   * 共有車両在庫の検討中車両の件数
   */
  private get sharedVehicleStockConsiderationCount$(): Observable<number> {
    // 検討分類A〜Dのいずれかを設定した車両を検索し、総件数を検討中の件数とする（明細は使わないため最小件数で取得）
    // 組織はログインユーザの所属組織、掲載区分は「掲載中」（＝在庫切れ除外）がAPI側の既定のため条件指定しない
    const request: ISharedVehicleStockSearchReq = {
      sharedVehicleStockClassificationA: true,
      sharedVehicleStockClassificationB: true,
      sharedVehicleStockClassificationC: true,
      sharedVehicleStockClassificationD: true,
      sharedVehicleStockPageSize: SharedVehicleStockConsiderationSearchPageSize,
    };

    // L-Stock-4030 共有車両在庫情報_検索（該当なしは204で本文が無いため0件とする）
    return this.sharedVehicleStockInfoResource.post<BlListResponseBody<ISharedVehicleStockInfo>>(
      request,
      { entityOptions: { exPath: 'sharedvehiclestocksearch' } }
    ).pipe(
      map(response => _isNil(response) || _isNil(response.totalCount) ? 0 : response.totalCount)
    );
  }

  /**
   * 共有車両在庫の検討中車両の件数を取得する
   */
  private getSharedVehicleStockConsiderationCount() {
    this.sharedVehicleStockConsiderationCount$
      .subscribe(
        (count) => {
          // 検討中の件数（検討中車両の赤バッジ）
          this.badge.sharedVehicleStock.consideration.final = count;
        },
        () => {
        },
        () => {
          if (this.timer.sharedVehicleStockConsideration) {
            clearTimeout(this.timer.sharedVehicleStockConsideration);
          }
          this.timer.sharedVehicleStockConsideration = setTimeout(() => {
            this.getSharedVehicleStockConsiderationCount();
          }, this.badgeInterval);
        });
  }

  /**
   * 該当する項目でEnterを押下した場合にClickイベントを発火させる
   * @param event
   */
  onKeyDownEnter(event) {
    event.target.click();
    // 基底のフォーカス処理を止める
    event.preventDefault();
    event.stopPropagation();
  }

  // onBackgroundClick : 背景クリック時にフォーカスを戻す
  onBackgroundClick() {
    if (this.currentTarget) {
      this.currentTarget.focus();
    } else { // フォーカス情報がない場合は、初期フォーカスへ戻す
      this.focusFirst();
    }
  }

  // onFocus : 現在のフォーカスを持つアイテムを記憶する
  onFocus(event) {
    this.isCurrentFocus = true;
    this.currentTarget = event.target;
  }

  // onBlur : 現在のフォーカスを持つアイテムをクリアする
  onBlur() {
    this.isCurrentFocus = false;
    setTimeout(() => { // 特定のフォーカスでない場合は、現在のフォーカスをクリアする
      if (!this.isCurrentFocus) {
        this.currentTarget = undefined;
      }
    }, 300);
  }

  onClickAppOption(serviceId) {
    this.modalService.show(AddOptionModalComponent, {
      data: { serviceId }
    })
      .subscribe(modalRef => {
        modalRef.hide();
      });
  }

  onClickDisableMenu(menu: BizMenuContentEx) {
    switch (menu.businessMenuStatus) {
      case BusinessMenuStatus.NoAuthority:
        _defer(() => {
          this.dialogService.info(menu.businessMenuStatusMessage)
            .pipe(take(1))
            .subscribe(modalRef => {
              modalRef.hide();
            });
        });
        break;
      case BusinessMenuStatus.NotSigned:
        this.onClickAppOption(menu.serviceId);
        break;
    }
  }

  onChangeTab(tabOption: any) {
    let needShowTutorial = false;
    const _tabOption = <BizMenuTabOption>tabOption;
    if (!_isNil(this.currentTab) && _tabOption.tabId === this.currentTab.tabId) {
      return;
    }

    // バッジデータ取得を一旦全て停止する
    _forEach(this.timer, timer => {
      clearTimeout(timer);
    });

    // 権限マスクを一旦解除
    this._showPermissionMask = false;

    switch (_tabOption.serviceId) {
      case ContractConst.SERVICEID_OPT_PMC_SALES:
        if (_tabOption.menuGroup.businessMenuGroupId === BusinessMenuGroupId.PartsTabPartsman) {
          // ページIDを変更する
          this.initFunctions(PageId.MenuPartsmanBiz);
          break;
        } else if (_tabOption.menuGroup.businessMenuGroupId === BusinessMenuGroupId.PerformanceTabPartsman) {
          this.initFunctions(PageId.Performance);
          break;
        } else if (_tabOption.menuGroup.businessMenuGroupId === BusinessMenuGroupId.AnalysisTabPartsman) {
          this.initFunctions(PageId.MenuAnalysisBiz);
          break;
        }
      case ContractConst.SERVICEID_OPT_PMC_BILL_MGT:
        this.initFunctions(PageId.MenuPmBillManageBiz);
        break;
      case ContractConst.SERVICEID_OPT_CMN_PURCHASE:
        this.initFunctions(PageId.MenuPurchaseBiz);
        break;
      case ContractConst.SERVICEID_OPT_CMN_ORDER:
        this.initFunctions(PageId.MenuPmOrderBiz);
        break;
      case ContractConst.SERVICEID_OPT_CMN_STOCKTAKING:
        this.initFunctions(PageId.MenuPmInventoriesBiz);
        break;
      case ContractConst.SERVICEID_PRODUCT_MAINTENANCE:
        this.pageService.deleteSfSlipDraft().subscribe(() => {
          this.getSfSlipCount();
        });

        // ページIDを変更する
        this.initFunctions();
        needShowTutorial = true;

        // 権限マスク判定
        this._showPermissionMask = !this.isPermissionMaintenance();
        break;
      case ContractConst.SERVICEID_PRODUCT_REPAIR:
        this.getRepairBadge();
        // ページIDを変更する
        this.initFunctions(PageId.MenuRepairBiz);

        // 権限マスク判定
        this._showPermissionMask = !this.isPermissionRepair();
        break;
      case ContractConst.SERVICEID_OPT_CMN_SALES_MGT_CORE:
      case ContractConst.SERVICEID_OPT_RECYCLE_SALES_MGT_CORE:
        this.clearDepositBadge();
        this.getDepositCount();
        // ページIDを変更する
        this.initFunctions(PageId.MenuDepositAndBilling);
        needShowTutorial = true;
        break;
      case ContractConst.SERVICEID_PRODUCT_RECYCLE:
        if (_tabOption.menuGroup.businessMenuGroupId === BusinessMenuGroupId.PerformanceTabRecycle) {
          this.initFunctions(PageId.Performance);
        } else {
          // バッジデータ取得
          this.getRecycleBadge(_tabOption.menuGroup.businessMenuGroupId);
          // Yahooサービス利用可能時のみ
          if (this.relationYahoo) {
            // Yahooのログイン有効期限チェック及び在庫数差異チェックについては、ログイン時のみ
            if (this.isFirstLogin) {
              this.isFirstLogin = false;
              this.checkYahooExpirationDate();
              this.checkYahooDiffExistFlag();
            }
            // 公開鍵期限切れチェックを行う
            this.checkYahooPublicKeyExpired();
          }
          this.initFunctions(PageId.MenuRecycleBiz);
        }
        break;
      case ContractConst.SERVICEID_OPT_CMN_CARSALES_ESTIMATE_ORDER:
      case ContractConst.SERVICEID_OPT_CMN_CARSALES_VEHICLESTOCK:
      case ContractConst.SERVICEID_OPT_CMN_CARSALES_PURCHASE:
        this.getCsSlipCount();
        if (_tabOption.menuGroup.businessMenuGroupId === BusinessMenuGroupId.DebtTabCarsales) {
          this.clearDepositBadge();
          this.getPaymentCount();
          this.getPurchaseSlipCount();
          this.initFunctions(PageId.MenuWithdrawalAndPayment);
        } else {
          this.initFunctions(PageId.CarSales);
        }
        // 権限マスク判定
        this._showPermissionMask = !this.isPermissionCarsales();
        break;
      case ContractConst.SERVICEID_PRODUCT_GLASS:
        this.clearDepositBadge();
        this.getDepositCount();
        this.initFunctions(PageId.MenuGlassBiz);
        break;
      case ContractConst.SERVICEID_OPT_CMN_PURCHASE_MGT_CORE:
      case ContractConst.SERVICEID_OPT_RECYCLE_PURCHASE_MGT_CORE:
        // 出金支払バッジ取得
        this.clearDepositBadge();
        this.getPaymentCount();
        this.initFunctions(PageId.MenuWithdrawalAndPayment);
        break;
      case ContractConst.SERVICEID_OPT_CMN_STOCK_MGT:
        this.initFunctions(PageId.MenuStock);
        break;
      case ContractConst.SERVICEID_OPT_CMN_BLORDER_BASE:
        this.clearPartsOrderBadge();
        this.initFunctions(PageId.MenuPartsOrderBiz);
        this.getPartsOrderCount();
        break;
      case ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK:
      case ContractConst.SERVICEID_OPT_CMN_LOAN_JOCAR:
      case ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE:
        this.initFunctions(PageId.CarSales);
        break;
      case ContractConst.SERVICEID_PRODUCT_PRICEPRINT:
        this.initFunctions(PageId.MenuPriceboard);
        break;
      case ContractConst.SERVICEID_OPT_CMN_PURCHASE_MAINTENANCE_REPAIR:
        this.clearDepositBadge();
        this.getPaymentCount();
        this.getPurchaseSlipCount();
        if (_tabOption.menuGroup.businessMenuGroupId === BusinessMenuGroupId.DebtTabRepair) {
          this.initFunctions(PageId.MenuWithdrawalAndPayment);
        } else {
          this.getPayoutMoveSlipCount();
          this.initFunctions(PageId.MenuPurchaseStock);
        }
        break;
      case ContractConst.SERVICEID_OPT_BLPAY_AFFILIATED:
        this.getBlPayAffiliatedCount();
        this.initFunctions(PageId.MenuBlPayAffiliated);
        break;
      case ContractConst.SERVICEID_OPT_BLPAY_SUPPLIERS:
        this.getBlPaySuppliersCount();
        this.initFunctions(PageId.MenuBlPaySuppliers);
        break;

      case ContractConst.SERVICEID_OPT_CMN_TAJIMA:
        this.initFunctions(PageId.MenuIsshinTasuke);
        break;
      case ContractConst.SERVICEID_PRODUCT_LOGISTICS:
        this.initFunctions(PageId.MenuDeliveryPf);
        break;
      case ContractConst.SERVICEID_OPT_CMN_SHARED_VEHICLE_STOCK:
        // メニューに対するロール制御はなし（権限マスク判定不要）
        this.getSharedVehicleStockCount();
        this.getSharedVehicleStockConsiderationCount();
        this.initFunctions(PageId.MenuSharedVehicleStock);
        break;
      default:
        this.initFunctions();
    }
    this.currentTab = _tabOption;

    if (this._showPermissionMask) {
      this.dialogService.info('権限がないため操作できません。').subscribe(
        modalRef => {
          modalRef.hide();
        }
      );
      return;
    }

    // 整備、鈑金或は車販場合
    if (ACTIVE_TAB_IDS.includes(this.currentTabId)) {
      // 画面動作設定情報を取得する
      this.fetchScreenActionSetting();
    }

    // 初回、チュートリアル表示
    this.loginResourceService.loginUserEmployeeBindModel$.subscribe(
      (user: ILoginUserEmployeeBindModel) => {
        if (!this.pageService.isLogin(user)) {
          return;
        }

        if (needShowTutorial) {
          // 自動チュートリアル表示
          this.showTutorialModal(user).subscribe(
            () => {
              this.afterFixedMaster();
            }
          );
        } else {
          // マスタチェックを待ってローディングを解除
          this.afterFixedMaster();
        }
      }
    );

    // カレンダー設定
    this.loginResourceService.getAvailableMainServiceIds().subscribe(
      (mainServiceIds) => {
        // 部品商契約時は部品商用の予約機能でチェックする
        if (_some(mainServiceIds, serviceId => serviceId === ContractConst.SERVICEID_PRODUCT_PARTSMAN)) {
          this._useReserveServiceId = ContractConst.SERVICEID_OPT_PMC_RESERVE_LINK;
        }

        // TODO: 暫定対応
        // サービスを複数契約していた場合や、選択中タブによって切り替える必要あり。

        // 表示しないサービスしか契約していない場合、予約ボタンを表示しない
        const hideServiceIds = [
          ContractConst.SERVICEID_PRODUCT_RECYCLE,
          ContractConst.SERVICEID_PRODUCT_GLASS,
          ContractConst.SERVICEID_PRODUCT_LOGISTICS,
        ];
        this.hideReserveBtn = mainServiceIds.every((svc) => {
          return hideServiceIds.includes(svc);
        });

        // カレンダーフッターの非表示制御
        const hideScheduleFooterServiceIds = [
          ContractConst.SERVICEID_PRODUCT_LOGISTICS,
        ];
        this.hideScheduleFooter = mainServiceIds.every((svc) => {
          return hideScheduleFooterServiceIds.includes(svc);
        });
      }
    );

    // 未手配アラート通知
    this.pageService.notArrangedNotice();
  }

  onClickTab(event) {
    event.autoSelect = false;
    if (!_isNil(this.currentTab) && this.currentTab.tabId === event.tabOption.tabId) {
      return;
    }
    if (event.tabOption.menuGroup.businessMenuStatus === BusinessMenuStatus.NoAuthority) {
      this.dialogService.info('このタブを表示する権限がありません。')
        .subscribe(modalRef => {
          modalRef.hide();
        });
      return;
    }
    this.navigateTab(event.tabOption.tabId);
  }

  private focusFirst() {
    _defer(() => {
      this.currentTarget = this.el.nativeElement.querySelector('.first-focus');
      if (this.currentTarget) {
        this.currentTarget.focus();
      }
    });
  }

  private openWindow(url) {
    window.open(url, '_blank');
  }

  /**
   * OEMカスタマイズスタイルを設定します。
   */
  private setOemCustomizeStyle() {
    this._oemBackgroundColor = '';

    if (this.oemCustomize && this.oemCustomize.oemCustomizeItemList) {
      // トップメニュー背景色変更
      const topBackGroundColorItem = _find(this.oemCustomize.oemCustomizeItemList,
        item => item.oemCustomizeItemId === OemCustomizeItemId.TopBackGroundColor);

      if (topBackGroundColorItem) {
        this._oemBackgroundColor = topBackGroundColorItem.oemCustomizeItemValue;
      }

      // 下部にに「Powered by BroadLeaf」の文字表示
      const topSignatureItem = _find(this.oemCustomize.oemCustomizeItemList,
        item => item.oemCustomizeItemId === OemCustomizeItemId.TopSignature);

      if (topSignatureItem) {
        this._oemSignature = true;
      }
    }
  }

  /**
   * ファンクションを初期化します。
   * @param pageId 画面ID
   */
  private initFunctions(pageId: PageId = PageId.MenuSfBiz) {
    // 一新多助メニュータブの場合、画面管理サービスには整備タブとして設定しておく
    // 「使い方をみる」で整備タブのチュートリアルが表示される
    let initPageId = pageId;
    if (pageId === PageId.MenuIsshinTasuke) {
      initPageId = PageId.MenuSfBiz;
    }

    this.screenService.initializeScreen(
      initPageId,
      // 第二引数 F2 ~ F8 で利用するファンクションを設定(未指定は非活性になります)
      [[]],
      'トップメニュー'
    ).subscribe();

    // F10をログアウトに変更
    this.screenService.setLogoutFnKey();

    // F11:戻る、F12:進む　Fnボタン非活性
    this.screenService.disableFnKey([FunctionRole.Prev, FunctionRole.Next]);

    // ファンクションを追加
    this.getFunctions(pageId).subscribe((functions) => {
      // OEMサイトリンクがある場合、F8をバブルメニューとして設定
      let bubbleMenuRole = (this.oemBubbleMenuList.length > 0) ? [FunctionRole.Toggle1Fn8] : null;
      // 整備、鈑金或は車販の場合かつAVISアドオンおよびローン関連サービスが無効の場合は、メンテナンス用のバブルメニューF6を追加で設定する
      if (this.maintenanceProductArr && this.maintenanceProductArr.length > 0 &&
        this.isMaintenance(pageId) && !this.isAvisAddonAvailable &&
        !this.isCmnLoanExternallinkAvailable && !this.isCmnLoanSingleAvailable) {
        if (bubbleMenuRole) {
          // 既にバブルメニューが設定されている場合（OEMサイトなど）
          bubbleMenuRole.push(FunctionRole.Toggle2Fn6);
        } else {
          // バブルメニューが未設定の場合は、メンテナンス用項目のみで新規に配列を作成
          bubbleMenuRole = [FunctionRole.Toggle2Fn6];
        }
      }
      if (bubbleMenuRole) {
        bubbleMenuRole.push(FunctionRole.Toggle2Fn2);
      } else {
        bubbleMenuRole = [FunctionRole.Toggle2Fn2];
      }

      this.screenService.setFunctions(functions, bubbleMenuRole).subscribe(
        functionRef => {
          switch (functionRef.role) {
            case FunctionRole.TextOutput:
              let url = '/output/output';
              const emptyQuery = new BlUrlQuery();
              if (!_isNil(this.currentTab.productCode)) {
                emptyQuery.setValue(BlUrlQueryKey.ProductCode, this.currentTab.productCode);
                url += `?${emptyQuery.getQueryString()}`;
              }
              functionRef.location(url, true);
              break;
            case FunctionRole.Toggle2Fn3:
              const transferUrl = '/accounting/transfer-status';
              functionRef.location(transferUrl, true);
              break;
            case FunctionRole.Toggle2Fn6: {
              // カスタム設定
              this.showCustomSettingBubble(functionRef);
              break;
            }
            case FunctionRole.Management:
              const managementUrl = '/managementreport/display';
              functionRef.location(managementUrl, true);
              break;
            case FunctionRole.ManagementDetail:
              const mngDetailUrl = '/managementreport/detail';
              functionRef.location(mngDetailUrl, true);
              break;
            case FunctionRole.Toggle1Fn5:
              if (pageId === PageId.MenuSfBiz || pageId === PageId.MenuRepairBiz || pageId === PageId.CarSales) {
                // NS伝票参照
                const nsHistorySearchUrl = '/dx/ns-history-search';
                functionRef.location(nsHistorySearchUrl, true);
              } else {
                const clauselistUrl = '/contract/dashboard/clause-list-page';
                functionRef.location(clauselistUrl, true);
              }
              break;
            case FunctionRole.Toggle1Fn8:
              if (this.currentTabId === MaintenanceTabId.IsshinTasuke) {
                // 一新多助のメニュー設定を表示
                this.showIsshinTasukeMenuSetting();
                functionRef.end();
              } else {
                functionRef.showBubble(this.oemBubbleMenuList).subscribe(
                  bubbleFunctionRef => {
                    this.onSelectedOemSiteLinkBubbleMenu(bubbleFunctionRef);
                  }
                );
                functionRef.end();
              }

              break;
            case FunctionRole.Toggle1Fn6:
              const threadsUrl = '/ss/threads';
              functionRef.location(threadsUrl, true);
              break;
            case FunctionRole.Toggle1Fn4:
              // 画面IDが仕入在庫であれば仕入在庫帳票を開く
              if (pageId === PageId.MenuPurchaseStock) {
                const stockCheckReportUrl = '/stock/stockcheckreport';
                functionRef.location(stockCheckReportUrl, true);
              } else if (
                (this.currentTabId === '5' || this.currentTabId === '6' || this.currentTabId === '7'
                  || this.currentTabId === '8' || this.currentTabId === '10' || this.currentTabId === '34'
                  || this.currentTabId === '12' || this.currentTabId === '13')) {
                const reportlistUrl = '/menu/report-output-status';
                functionRef.location(reportlistUrl, true);
              } else if (this.currentTabId === '19') {
                const glassDmSealPrintUrl = '/glass/glass-dm-seal-print';
                functionRef.location(glassDmSealPrintUrl, true);
              }
              break;
            case FunctionRole.Toggle1Fn2:
              if (
                pageId === PageId.MenuSfBiz || pageId === PageId.MenuRepairBiz || pageId === PageId.CarSales ||
                pageId === PageId.MenuDepositAndBilling || pageId === PageId.MenuWithdrawalAndPayment ||
                pageId === PageId.MenuPurchaseStock || pageId === PageId.MenuIsshinTasuke
              ) {
                const reportlistUrl = 'quick/search';
                functionRef.location(reportlistUrl, true);
              } else {
                if (this.currentTabId === '12') { // 実績タブ
                  // 汎用データ出力基本サービス(SBLCMN-140090)が導入済み、かつ売上伝票情報のテキスト出力(BF390-100700-E)のロールが有効な場合、
                  // 実績タブにデータ出力／出力履歴を表示
                  if (this._isPmcDataOutput) {
                    // 汎用データ出力
                    const reportlistUrl = '/output/request/data';
                    functionRef.location(reportlistUrl, true);
                  } else {
                    const reportlistUrl = '/output/request';
                    functionRef.location(reportlistUrl, true);
                  }
                } else if (this.currentTabId === '19') {
                  // 硝子用実績タブの場合に汎用データ出力の硝子商へ遷移
                  const reportlistUrl = '/output/request/4';
                  functionRef.location(reportlistUrl, true);
                }
              }
              break;
            case FunctionRole.Toggle1Fn3:
              if (this.currentTabId === '12') { // 実績タブ
                // 汎用データ出力履歴
                if (this._isPmcDataOutput) {
                  // 汎用データ出力
                  const reportlistUrl = '/output/history/0';
                  functionRef.location(reportlistUrl, true);
                } else {
                  const reportlistUrl = '/output/history';
                  functionRef.location(reportlistUrl, true);
                }
              } else if (this.currentTabId === '19') {
                // 硝子用実績タブの場合に汎用データ出力履歴へ遷移
                const reportlistUrl = '/output/history';
                functionRef.location(reportlistUrl, true);
              }
              break;
            case FunctionRole.Toggle2Fn7:
              switch (pageId) {
                case PageId.MenuSfBiz:
                case PageId.MenuRepairBiz:
                  this.loadingService.show();
                  ObservableForkJoin(
                    this.loginResourceService.getAllServiceAvailabilityInfo(),
                    this.loginResourceService.getAllUserUnavailablePermission()
                  )
                  .subscribe(([serviceAvailabilities, permissions]) => {
                    this.loadingService.hide();
                    const availableServiceIds = _compact(_map(serviceAvailabilities, availability => availability.serviceId));
                    const deniedFunctionIds = _compact(_map(permissions, permission => permission.blFunctionId));

                    const activeRules = _filter(SF_REPAIR_OUTPUT_HISTORY_TRANSITION_RULES, rule =>
                      _some(rule.serviceIds, serviceId => availableServiceIds.includes(serviceId)));
                    const dataHistoryRoleIds: string[] = [];
                    const permissionLabels: string[] = [];
                    _forEach(activeRules, (rule) => {
                      dataHistoryRoleIds.push(...rule.roleIds);
                      permissionLabels.push(rule.permissionLabel);
                    });

                    if (
                      !_every(
                        dataHistoryRoleIds,
                        roleId => deniedFunctionIds.includes(roleId)
                      )) {
                      const dataHistoryUrl = PagePath.OutputHistory;
                      functionRef.location(dataHistoryUrl, true);
                    } else {
                      const errorMessage = `${permissionLabels.join('または')}の権限がありません。`;
                      this.dialogService.info(errorMessage).subscribe((dialogRef) => {
                        dialogRef.hide();
                      });
                    }
                  },
                  (error) => {
                    this.loadingService.hide();
                    throw error;
                  });
                  functionRef.end();
                  break;
                default:
                  break;
              }
              break;
            case FunctionRole.BubbleFn8:
              if (this.currentTabId === '5') {
                const ftcautologintUrl = '/pm/ftc-auto-login';
                const newWindow = window.open(ftcautologintUrl, '_blank');
                // ウィンドウが正常に開かれたか確認
                if (newWindow) {
                  // storageイベントハンドラーを定義
                  const handleStorageEvent = () => {
                    // LocalStorageからエラー情報を取得
                    const error = LocalStorageUtils.get('FTC_AUTO_LOGIN_ERROR');
                    // エラーが存在する場合、新しいウィンドウを閉じ、イベントリスナーを解除
                    if (error) {
                      // 新しいウィンドウを閉じる
                      newWindow.close();
                    }
                    // storageイベントのリスナーを解除
                    window.removeEventListener('storage', handleStorageEvent);
                    LocalStorageUtils.remove('FTC_AUTO_LOGIN_ERROR');
                  };
                  // storageイベントを監視するリスナーを追加
                  window.addEventListener('storage', handleStorageEvent);
                }
              }
              functionRef.end();
              break;
            case FunctionRole.Toggle1Fn7:
              if (this.currentTabId === BusinessMenuGroupId.PartsOrder + '') {
                this.openWindow(PagePath.BlpHistory);
              }
              functionRef.end();
              break;
            case FunctionRole.Toggle2Fn2:
              if (this.currentTabId === String(BusinessMenuGroupId.CreditTabPartsman)) {
                this.loginResourceService.isAvailableFunction(
                  [RoleConst.ROLEID_FUNC_PMC_BILLINGBALANCEPDF_ISSUE, RoleConst.ROLEID_FUNC_PMC_ACCRECBALANCEPDF_ISSUE],
                  true,
                  PermissionCondition.Or
                ).subscribe(
                  permissions => {
                    // 権限がない場合
                    if (!permissions) {
                      this.dialogService.error('請求売掛残高PDF出力操作権限がありません').subscribe((blModalRef) => {
                        blModalRef.hide();
                      });
                      functionRef.end();
                    } else {
                      // データ出力操作バブルメニュー
                      const bubbleMenus = <any[]>[
                        /* F2:PDF出力状況 */
                        FnKey.BubbleFn2.setLabel('PDF出力状況'),
                        /* F3:PDF出力 */
                        FnKey.BubbleFn3.setLabel('PDF出力'),
                        /* F4:並び順設定 */
                        FnKey.BubbleFn4.setLabel('並び順設定'),
                        //  ファンクションメニューに空白箇所に「ファンクションメニューは【ESC】で戻ること可能」の旨の文言を入れる */
                        FnKey.BubbleFn12.disable().setLabel('【ESC】で戻る'),
                      ];
                      functionRef.showBubble(bubbleMenus).subscribe(
                        bubbleFunctionRef => {
                          this.onSelectedPDFBubbleMenu(bubbleFunctionRef);
                        }
                      );
                      functionRef.end();
                    }
                  }
                );
              } else if (this.currentTabId === String(BusinessMenuGroupId.DebtTabPartsman)) {
                this.loginResourceService.isAvailableFunction(
                  [RoleConst.ROLEID_FUNC_PMC_PAYMENTBALANCEPDF_ISSUE, RoleConst.ROLEID_FUNC_PMC_ACCPAYBALANCEPDF_ISSUE],
                  true,
                  PermissionCondition.Or
                ).subscribe(
                  permissions => {
                    // 権限がない場合
                    if (!permissions) {
                      this.dialogService.error('支払買掛残高PDF出力操作権限がありません').subscribe((blModalRef) => {
                        blModalRef.hide();
                      });
                      functionRef.end();
                    } else {
                      // データ出力操作バブルメニュー
                      const bubbleMenus = <any[]>[
                        /* F2:PDF出力状況 */
                        FnKey.BubbleFn2.setLabel('PDF出力状況'),
                        /* F3:PDF出力 */
                        FnKey.BubbleFn3.setLabel('PDF出力'),
                        /* F4:並び順設定 */
                        FnKey.BubbleFn4.setLabel('並び順設定'),
                        //  ファンクションメニューに空白箇所に「ファンクションメニューは【ESC】で戻ること可能」の旨の文言を入れる */
                        FnKey.BubbleFn12.disable().setLabel('【ESC】で戻る'),
                      ];
                      functionRef.showBubble(bubbleMenus).subscribe(
                        bubbleFunctionRef => {
                          this.onSelectedPDFBubbleMenu(bubbleFunctionRef);
                        }
                      );
                      functionRef.end();
                    }
                  }
                );
              }
              break;
            default:
              functionRef.end();
              break;
          }
        }
      );

      // F10をログアウトに変更（setFunctionsを呼び出すともとに戻るため、再度設定）
      this.screenService.setLogoutFnKey();
    });
  }

  /**
   * ファンクションを取得します。
   * @param pageId 画面ID
   * @returns ファンクション配列
   */
  private getFunctions(pageId: PageId): Observable<any[][]> {

    return ObservableForkJoin(
      this.loginResourceService.getAllServiceAvailabilityInfo(),
      this.loginResourceService.getAllUserUnavailablePermission(),
      this.loginResourceService.getAvailableMainServiceIds(),
    ).pipe(
      map(
        responses => {

          const availabilities = _compact(_map(responses[0], availability => availability.serviceId));
          const denyPermissions = _compact(_map(responses[1], permission => permission.blFunctionId));
          const productAvailabilities = responses[2] || [] as string[];
          const func1 = new Array();
          const func2 = new Array();

          // テキスト出力
          // データ出力オプションが有効かつログインユーザーにテキスト出力の権限がある場合、
          // 画面IDが整備または鈑金であればトグル２のファンクションに追加
          if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_DATA_OUTPUT)
            && !denyPermissions.includes(RoleConst.ROLEID_MENU_ALL_TEXT_OUTPUT)) {
            if (pageId === PageId.MenuSfBiz || pageId === PageId.MenuRepairBiz
              || pageId === PageId.MenuRecycleBiz) {
              func2.push(FnKey.TextOutput);
            }
          }

          // 画面IDが整備、鈑金、車販の何れかの場合かつAVISアドオンおよびローン関連サービスが無効の場合トグル2のF6に追加
          // 利用可能なサービスリストにAvisアドオンが含まれているかを判定し、結果をフラグに保持します
          this.isAvisAddonAvailable = availabilities.includes(ContractConst.SERVICEID_OPT_AVIS_ADDON);
          // 利用可能なサービスリストにローン申込外部連携が含まれているかを判定し、結果をフラグに保持します
          this.isCmnLoanExternallinkAvailable = availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_EXTERNALLINK);
          // 利用可能なサービスリストにローン申込単独利用が含まれているかを判定し、結果をフラグに保持します
          this.isCmnLoanSingleAvailable = availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_SINGLE);
          // 取得済みのサービス可用情報を再利用し、重複API呼び出しを避けながら表示時と実行時の共通ゲートにする。
          this.isCaseEvidenceAutoRegistAvailable = _some(
            responses[0],
            availability => availability.serviceId === ContractConst.SERVICEID_OPT_CMN_CASE_EVIDENCE_AUTO_REGIST
              && availability.serviceAvailableFlag === true
          );
          // メンテナンス対象のプロダクトコードを設定します
          this.maintenanceProductArr = this.getAvailableMaintenanceProducts(availabilities);
          if (this.maintenanceProductArr && this.maintenanceProductArr.length > 0 &&
            this.isMaintenance(pageId) && !this.isAvisAddonAvailable &&
            !this.isCmnLoanExternallinkAvailable && !this.isCmnLoanSingleAvailable &&
            this.hasRequiredRepairEstimateServices(pageId, availabilities)) {
            // カスタム設定
            func2.push(FnKey.Toggle2Fn6.setLabel(ButtonLabels.TOGGLE_MENU_CUSTOM_SETTING));
          }

          // 会計連携
          // 整備サービス、会計連携オプションが有効かつログインユーザーにテキスト出力の権限がある場合、
          // 画面IDが整備または入金請求であればトグル１のファンクションに追加
          if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_BASE_ACCOUNTING_LINK)
            && availabilities.includes(ContractConst.SERVICEID_OPT_MAINTENANCE_BASE)
            && !denyPermissions.includes(RoleConst.ROLEID_MENU_ACCOUNTING_LINK_STATUS)) {
            if (pageId === PageId.MenuSfBiz || pageId === PageId.MenuDepositAndBilling) {
              func2.push(FnKey.Toggle2Fn3.setLabel('会計連携状況'));
            }
          }

          // クイック検索
          // クイック検索オプションが有効、かつAVISアドオンが無効の場合、トグル１のF2に追加
          if (
            availabilities.includes(ContractConst.SERVICEID_OPT_CMN_QUICK_SEARCH) &&
            !availabilities.includes(ContractConst.SERVICEID_OPT_AVIS_ADDON)
          ) {
            if (
              pageId === PageId.MenuSfBiz || pageId === PageId.MenuRepairBiz || pageId === PageId.CarSales ||
              pageId === PageId.MenuDepositAndBilling || pageId === PageId.MenuWithdrawalAndPayment || pageId === PageId.MenuPurchaseStock ||
              pageId === PageId.MenuIsshinTasuke
            ) {
              let quickSearchFn = FnKey.Toggle1Fn2.setLabel('クイック検索');

              // クイック検索の権限がない場合は非活性
              if (denyPermissions.includes(RoleConst.ROLEID_FUNC_ALL_QUICK_SEARCH)) {
                quickSearchFn = quickSearchFn.disable();
              }
              func1.push(quickSearchFn);
            }
          }

          // 売上目標進捗
          // 画面IDが整備、鈑金、入金請求の何れかであればトグル１のファンクションに追加
          // ※ただし、Recycle+ or 受発注PFの単体版の場合は、入金請求タブであっても追加しない
          // BIツール連携サービスが有効の場合はカレンダー下にボタンを表示するためファンクション無し
          if (!availabilities.includes(ContractConst.SERVICEID_OPT_CMN_BI_TOOL)) {
            if (
              pageId === PageId.MenuSfBiz ||
              pageId === PageId.MenuRepairBiz ||
              pageId === PageId.MenuIsshinTasuke ||
              (
                pageId === PageId.MenuDepositAndBilling &&
                !this.isSingleProductAvailable(
                  productAvailabilities,
                  [ContractConst.SERVICEID_PRODUCT_RECYCLE, ContractConst.SERVICEID_PRODUCT_BLORDER]
                )
              )
            ) {
              if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_SALESTARGET_PROGRESSTOTAL)) {
                func1.push(FnKey.Management);
              }
            }
          }

          // 実績詳細
          // 画面IDが整備、鈑金、車販、入金請求の何れかであればトグル１のファンクションに追加
          // 画面IDが整備または入金請求であればトグル１のファンクションに追加
          if (
            pageId === PageId.MenuSfBiz ||
            pageId === PageId.MenuRepairBiz ||
            pageId === PageId.CarSales ||
            pageId === PageId.MenuIsshinTasuke ||
            (
              pageId === PageId.MenuDepositAndBilling &&
              !this.isSingleProductAvailable(
                productAvailabilities,
                [ContractConst.SERVICEID_PRODUCT_RECYCLE, ContractConst.SERVICEID_PRODUCT_BLORDER]
              )
            )
          ) {
            if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_MNGREPORT) ||
              availabilities.includes(ContractConst.SERVICEID_OPT_CMN_LOAN_BASE)) {
              func1.push(FnKey.ManagementDetail);
            }
          }

          // 規約
          if (
            (availabilities.includes(ContractConst.SERVICEID_PRODUCT_RECYCLE) && pageId === PageId.MenuRecycleBiz) ||
            (
              _some(productAvailabilities, product => product === ContractConst.SERVICEID_PRODUCT_BLORDER) &&
              pageId === PageId.MenuPartsOrderBiz
            )
          ) {
            func1.push(FnKey.Toggle1Fn5.setLabel('規約'));
          }

          // NS伝票参照
          // 「規約」がF5を使用しているが、現状は整備、鈑金、車販メニューのみ対象とするためF5を使用する
          if (
            (pageId === PageId.MenuSfBiz || pageId === PageId.MenuRepairBiz || pageId === PageId.CarSales) &&
            availabilities.includes(ContractConst.SERVICEID_OPT_CMN_NS_HISTORY_SEARCH)
          ) {
            func1.push(FnKey.Toggle1Fn5.setLabel('NS伝票参照'));
          }

          // OEMサイトリンク
          this.setOemSiteLinkBubbleMenu();

          // F8
          // タジマオプションが有効の場合、「一新多助設定」を追加
          if (this.currentTabId === MaintenanceTabId.IsshinTasuke) {
            func1.push(FnKey.Toggle1Fn8.setLabel('一新多助設定'));
          } else if (this.oemBubbleMenuList.length > 0) {
            func1.push(FnKey.Toggle1Fn8.setLabel('サイトリンク'));
          }

          // 社内連絡
          // 社内チャットサービスが有効の権限がある場合に追加
          if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_INTERNAL_CHAT)) {
            func1.push(FnKey.Toggle1Fn6.setLabel('社内連絡'));
            // ロールがないときは非活性
            this.isAvailableInternalContactDispRole().subscribe((enable) => {
              if (!enable) {
                this.screenService.disableFnKey([FunctionRole.Toggle1Fn6]);
              }
            });
          }

          // 仕入在庫帳票
          // 画面IDが仕入在庫であればトグル１のファンクションに追加
          if (pageId === PageId.MenuPurchaseStock) {
            if (
              availabilities.includes(ContractConst.SERVICEID_OPT_CMN_PURCHASE_MAINTENANCE_REPAIR) ||
              availabilities.includes(ContractConst.SERVICEID_OPT_CMN_STOCK_MGT_MAINTENANCE_REPAIR)
            ) {
              func1.push(FnKey.Toggle1Fn4.setLabel('仕入在庫帳票'));
              // ロールがないときは非活性
              this.isAvailablePurchaseStockReport().subscribe((enable) => {
                if (!enable) {
                  this.screenService.disableFnKey([FunctionRole.Toggle1Fn4]);
                }
              });
            }
          }
          // 部品商の場合タブを多段表示する
          if (productAvailabilities.includes(ContractConst.SERVICEID_PRODUCT_PARTSMAN)) {
            this._multiStage = BlTabMultiStage.MultiStage;
            this.showNavTabsAccordionContent();
            if (
              (this.currentTabId === '5' || this.currentTabId === '6' || this.currentTabId === '7'
                || this.currentTabId === '8' || this.currentTabId === '10' || this.currentTabId === '34'
                || this.currentTabId === '12' || this.currentTabId === '13')) {
              func1.push(FnKey.Toggle1Fn4.setLabel('印刷状況'));
            }
            // 表示条件：1.部品商タブ
            // 2.SBLPMC-320020 BLP新品部品受注サービス　がONの時
            if (this.currentTabId === '5' && availabilities.includes(ContractConst.SERVICEID_OPT_PMC_BLP_NEW_PARTS_ORDER)) {
              func1.push(FnKey.BubbleFn8.setLabel('決済確認'));
            }
          }
          // 汎用データ出力基本サービス(SBLCMN-140090)が導入済み、かつ売上伝票情報のテキスト出力(BF390-100700-E)のロールが有効な場合、
          // 実績タブにデータ出力／出力履歴を表示
          if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_GENERIC_DATA_OUTPUT)
            && !denyPermissions.includes(RoleConst.ROLEID_FUNC_ALL_SALESSLIP_TEXT_OUTPUT)) {
            if (availabilities.includes(ContractConst.SERVICEID_PRODUCT_PARTSMAN)) {
              this._isPmcDataOutput = true;
            } else {
              this._isPmcDataOutput = false;
            }
            if (this.currentTabId === '12') { // 実績タブ
              func1.push(FnKey.Toggle1Fn2.setLabel('データ出力'));
              func1.push(FnKey.Toggle1Fn3.setLabel('出力履歴'));
            }
          }
          // 硝子汎用データ出力サービスまたは硝子汎用データ出力サービス（価格有）が有効かつ、テキスト出力ロールが有効の場合
          if ((availabilities.includes(ContractConst.SERVICEID_OPT_GLASS_CMN_GENERIC_DATA_OUTPUT)
            || availabilities.includes(ContractConst.SERVICEID_OPT_GLASS_CMN_GENERIC_DATA_OUTPUT_PRICE))
            && !denyPermissions.includes(RoleConst.ROLEID_MENU_GLC_EXPORT)
          ) {
            // 硝子用実績タブ
            if (this.currentTabId === '19') {
              func1.push(FnKey.Toggle1Fn2.setLabel('データ出力'));
              func1.push(FnKey.Toggle1Fn3.setLabel('出力履歴'));
            }
          }
          // 硝子DMシール印刷画面への遷移用ファンクション
          if (availabilities.includes(ContractConst.SERVICEID_OPT_GLC_GLASS_DM_SEAL_PRINT)) {
            // 硝子用実績タブ
            if (this.currentTabId === '19') {
              func1.push(FnKey.Toggle1Fn4.setLabel('DMシール'));
            }
          }

          if (availabilities.includes(ContractConst.SERVICEID_OPT_CMN_CONTACT_ORDER_NEWPART)) {
            if (this.currentTabId === BusinessMenuGroupId.PartsOrder + '') {
              func1.push(FnKey.Toggle1Fn7.setLabel('BLP履歴'));
            }
          }

          // サービス(SBLCMN-140300)が導入済みな場合、
          // 入金請求タブ／出金支払タブに追加帳票出力を表示
          if (availabilities.includes(ContractConst.SERVICEID_OPT_PMC_LIST_TABLE_OUTPUT)) {
            if (this.currentTabId === String(BusinessMenuGroupId.CreditTabPartsman)
              || this.currentTabId === String(BusinessMenuGroupId.DebtTabPartsman)) { // 入金請求タブ/出金支払タブ
              func2.push(FnKey.Toggle2Fn2.setLabel('追加帳票出力'));
            }
          }

          switch (pageId) {
            case PageId.MenuSfBiz:
            case PageId.MenuRepairBiz: {
              const dataHistoryOptions = [
                ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_VEHICLE_INSP_INVITATION,
                ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_CUST_VCLE_FREE_SEARCH,
                ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_PERIODIC_INSP_INVITATION,
                ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_COMPLETE_INVITATION,
                ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_PRDC_EXCHG_LATER_DATE,
                ContractConst.SERVICEID_OPT_CMN_CASE_EVIDENCE_AUTO_REGIST
              ];
              if (_some(dataHistoryOptions, option => availabilities.includes(option))) {
                func2.push(FnKey.Toggle2Fn7.setLabel('ﾃﾞｰﾀ出力履歴'));
              }
              break;
            }
            default:
              break;
          }

          if (pageId === PageId.MenuPartsOrderBiz) {
            // 表示すべきものがないので2ページ目は不要
            return [func1];
          } else {
            return [func1, func2];
          }
        }
      )
    );
  }

  /**
   * OEMサイトリンクバブルメニューを設定します。
   */
  private setOemSiteLinkBubbleMenu() {
    if (this.oemCustomize && this.oemCustomize.oemCustomizeItemList) {
      this.oemBubbleMenuList = [];
      this.oemSiteLinkList = [];

      _forEach(this.oemCustomize.oemCustomizeItemList, item => {
        const array = item.oemCustomizeItemValue.split(',');

        if (array.length === 2) {
          switch (item.oemCustomizeItemId) {
            case OemCustomizeItemId.TopSiteLinkUrl1:
              this.oemBubbleMenuList.push(FnKey.BubbleFn1.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn1, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl2:
              this.oemBubbleMenuList.push(FnKey.BubbleFn2.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn2, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl3:
              this.oemBubbleMenuList.push(FnKey.BubbleFn3.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn3, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl4:
              this.oemBubbleMenuList.push(FnKey.BubbleFn4.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn4, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl5:
              this.oemBubbleMenuList.push(FnKey.BubbleFn5.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn5, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl6:
              this.oemBubbleMenuList.push(FnKey.BubbleFn6.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn6, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl7:
              this.oemBubbleMenuList.push(FnKey.BubbleFn7.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn7, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl8:
              this.oemBubbleMenuList.push(FnKey.BubbleFn8.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn8, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl9:
              this.oemBubbleMenuList.push(FnKey.BubbleFn9.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn9, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl10:
              this.oemBubbleMenuList.push(FnKey.BubbleFn10.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn10, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl11:
              this.oemBubbleMenuList.push(FnKey.BubbleFn11.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn11, url: array[1] });
              break;
            case OemCustomizeItemId.TopSiteLinkUrl12:
              this.oemBubbleMenuList.push(FnKey.BubbleFn12.setLabel(array[0]));
              this.oemSiteLinkList.push({ fnRole: FunctionRole.BubbleFn12, url: array[1] });
              break;
          }
        }
      });
    }
  }

  /**
   * OEMサイトリンクバブルメニュー選択イベントハンドラ
   * @param functionRef ファンクション情報管理クラス
   */
  private onSelectedOemSiteLinkBubbleMenu(functionRef: FunctionRef) {
    const findLink = _find(this.oemSiteLinkList, item => item.fnRole === functionRef.role);
    if (findLink) {
      window.open(findLink.url, '_blank');
    }
    functionRef.end();
  }

  private get bizMenu$(): Observable<BizMenu> {
    return ObservableForkJoin(
      this.bizMenuResource.getAll<IBizMenu>(),
      this.loginResourceService.getAllServiceAvailabilityInfo()
    ).pipe(
      map(response => {
        const productCode = _filter(_map(response[0].searchResultList, val => {
          if (val.businessMenuStatus !== BusinessMenuStatus.Available
            && val.businessMenuStatus !== BusinessMenuStatus.NoAuthority) {
            return null;
          }
          return this.serviceIdToProductCode(val.serviceId);
        }), val => !_isNil(val));
        const bizMenuGroup: BizMenuGroup = {};
        const tabOptions: BizMenuTabOption[] = [];

        _filter(response[0].searchResultList, menuGroup =>
          menuGroup.businessMenuStatus !== BusinessMenuStatus.Hidden

        ).forEach(menuGroup => {
          const isShowDraftExplanatoryNote = !this.hiddenExplanatoryNotes.draft.includes(menuGroup.businessMenuGroupId);
          const tabOption: BizMenuTabOption = {
            tabId: `${menuGroup.businessMenuGroupId}`,
            productCode: this.serviceIdToProductCode(menuGroup.serviceId),
            elementId: `menu-${menuGroup.businessMenuGroupId}`,
            label: menuGroup.businessMenuGroupName,
            classes: [],
            menuGroup: menuGroup,
            serviceId: menuGroup.serviceId,
            isShowDraftExplanatoryNote: isShowDraftExplanatoryNote,
            isShowStayExplanatoryNote: !this.hiddenExplanatoryNotes.stay.includes(menuGroup.businessMenuGroupId),
            right: menuGroup.rightAndLeftDiv === RightAndLeftDiv.Right,
            isShowBlPayAffiliatedNote: menuGroup.businessMenuGroupId === BusinessMenuGroupId.BLPayAffiliated,
            isShowBlPaySuppliersNote: menuGroup.businessMenuGroupId === BusinessMenuGroupId.BLPaySuppliers,
            isShowSharedVehicleStockNote: menuGroup.businessMenuGroupId === BusinessMenuGroupId.SharedVehicleStock,
          };

          if (menuGroup.businessMenuIconCss) {
            tabOption.classes.push(menuGroup.businessMenuIconCss);
          }

          switch (menuGroup.businessMenuStatus) {
            case BusinessMenuStatus.Available:
              break;
            case BusinessMenuStatus.NoAuthority:
              break;
            case BusinessMenuStatus.NotSigned:
              tabOption.labelHtml = this.sanitizer.bypassSecurityTrustHtml(
                `${tabOption.label}<span class="icon-icon_lock"></span>`
              );
              break;
            case BusinessMenuStatus.NowPreparing:
              tabOption.labelHtml = this.sanitizer.bypassSecurityTrustHtml(
                `${tabOption.label}<span class="glyphicon glyphicon-time clock"></span>`
              );
              break;
          }

          // 有効なタブで最初のタブを初期選択とする
          tabOption.disabled = [
            BusinessMenuStatus.Available,
            BusinessMenuStatus.NotSigned,
          ].includes(menuGroup.businessMenuStatus) === false;

          bizMenuGroup[tabOption.tabId] = this.createBizMenuItems(menuGroup, response[1], isShowDraftExplanatoryNote);
          tabOptions.push(tabOption);
        });

        return { productCode, bizMenuGroup, tabOptions };
      })
    );
  }

  private get loginUserEmployeeBindModel$(): Observable<ILoginUserEmployeeBindModel> {
    return Observable.create(subscriber => {
      const subscription = this.loginResourceService.loginUserEmployeeBindModel$
        .subscribe(val => {
          subscriber.next(val);
        }, err => {
          subscriber.error(err);
        });

      this.subscriptions.push(subscription);
    });
  }

  private eventIds$(productCode: string | string[], organizationCode: string): Observable<string[]> {
    const condition = new BlApiSearchCondition();
    let conditionProductCode: string;
    if (typeof productCode === 'string') {
      conditionProductCode = BlApiConditionHelper.makeCondStrEqual('productCode', productCode);
    } else {
      conditionProductCode = BlApiConditionHelper.makeCondStrIn('productCode', productCode);
    }
    condition.addCondition(
      BlApiConditionHelper.makeCondAnd(
        conditionProductCode,
        BlApiConditionHelper.makeCondStrEqual('organizationCode', CompanyConst.ORGANIZATION_CODE_ALL_COMPANY),
        BlApiConditionHelper.makeCondStrEqual('logicalDeleteDiv', LogicalDeleteDiv.Valid),
      ),
      BlApiConditionHelper.makeCondAnd(
        conditionProductCode,
        BlApiConditionHelper.makeCondStrEqual('organizationCode', organizationCode),
        BlApiConditionHelper.makeCondStrEqual('logicalDeleteDiv', LogicalDeleteDiv.Valid),
      )
    );

    const searchParam = {
      conditions: condition,
      sortFields: [
        { field: 'organizationCode', desc: false },
        { field: 'itemServiceDispOrder', desc: false },
      ],
    };

    return this.itemServiceSettingResource.getAll<IItemServiceSetting>(searchParam).pipe(
      map(
        response => {
          return _uniq(_map(response.searchResultList, itemService => itemService.scheduleEventMst.eventID));
        }
      ),
      catchError(
        () => {
          // イベントIDの取得に失敗しても業務は止めたくないので、空で返却
          return ObservableOf([]);
        }
      )
    );
  }

  private selectTab(tabId?: string) {
    if (this.selectTabSubscription) {
      this.selectTabSubscription.unsubscribe();
    }
    this.selectTabSubscription = this.initialized
      .subscribe(() => {
        if (_isNil(tabId)) {
          tabId = this.getDefaultTab();
        }
        if (_isNil(_find(this.tabOptions, val => val.tabId === tabId))) {
          this.navigateTab();
          return;
        }
        this.currentTabId = tabId;
        this.tabContainerService.select(tabId);
      });
  }

  private getDefaultTab(): string {
    let findTab = null;

    findTab = this.tabOptions.find(t => {
      return t.defaultActive === true;
    });
    if (!findTab) {
      findTab = this.tabOptions.find(t => {
        return t.menuGroup.businessMenuStatus === BusinessMenuStatus.Available;
      });
    }
    if (findTab) {
      return findTab.tabId;
    }
    return '1';
  }

  private navigateTab(tabId?: string) {
    this.router.navigate([], { fragment: tabId });
  }

  /**
   * ログイン情報が変更した場合の処理
   *
   */
  private changeLoginStatus() {
    if (this.changeLoginStatusSubscription) {
      this.changeLoginStatusSubscription.unsubscribe();
    }
    this.changeLoginStatusSubscription = this.changed.subscribe(() => {
      if (_isNil(this.currentTab)) {
        return;
      }
      switch (this.currentTab.serviceId) {
        case ContractConst.SERVICEID_OPT_CMN_SALES_MGT_CORE:
        case ContractConst.SERVICEID_OPT_RECYCLE_SALES_MGT_CORE:
          // 入金のバッチ件数再取得
          this.clearDepositBadge();
          this.getDepositCount();
          break;
        case ContractConst.SERVICEID_OPT_CMN_PURCHASE_MGT_CORE:
        case ContractConst.SERVICEID_OPT_RECYCLE_PURCHASE_MGT_CORE:
          // 出金のバッチ件数再取得
          this.clearDepositBadge();
          this.getPaymentCount();
          break;
      }
    });
  }

  private get initialized(): Observable<any> {
    return this.initializedSubject.asObservable()
      .pipe(
        filter(complete => complete),
        take(1),
      );
  }

  /**
   * 状態の変更処理
   */
  private get changed(): Observable<any> {
    return this.initializedSubject.asObservable()
      .pipe(
        filter(complete => complete),
        skip(1),
      );
  }

  /**
   * 使い方ダイアログを開く（自動）
   * @return モーダルを表示した場合`true`、しなかった場合`false`を流してcompleteします。
   */
  private showTutorialModal(user: ILoginUserEmployeeBindModel): Observable<boolean> {
    // ２重起動防止
    if (this.isShownTutorialModal) {
      return ObservableOf(false);
    }

    const genericFlagKey = `${user.blUserId}.never-auto-tutorial`;

    return new Observable(subscriber => {
      // 自動起動設定を確認して表示するかしないか判断する
      this.pageService.getGenericFlag(genericFlagKey).subscribe(
        genericFlag => {
          if (_isNil(genericFlag) || !genericFlag.genericFlagValue) {
            // チュートリアルモーダル表示
            this.isShownTutorialModal = true;
            this.modalService.show(
              TutorialModalComponent,
              { data: { autoDisplay: true } }
            ).subscribe(
              (modalRef: BlModalRef) => {
                // 自動起動設定が指定されていれば保存する
                const result = modalRef.getResults();
                if (result.neverAutoDisplay) {
                  this.pageService.saveGenericFlag(genericFlagKey, true, _isNil(genericFlag))
                    .subscribe();
                }
                modalRef.hide(this.currentTarget);
                this.isShownTutorialModal = false;
                subscriber.next(true);
                subscriber.complete();
                return;
              }
            );
          } else {
            subscriber.next(false);
            subscriber.complete();
            return;
          }
        }
      );
    });
  }

  /**
   * マスターデータ自動登録後処理
   */
  private afterFixedMaster() {
    this.loadingService.show();
    this.pageService.getMasterFixedInfo().subscribe((info: IMasterAutoInsert) => {
      this.loadingService.hide();
      // 自動登録が発生していれば、メッセージを表示してマスメンを別タブ起動
      if (info.masterAutoInsertResultDiv === MasterAutoInsertResultDiv.SuccessMessage && info.messageContents) {
        this.dialogService.info(info.messageContents).subscribe(
          (modalRef: BlModalRef) => {
            modalRef.hide();
            // ダイアログが消えてから新規タブが開くように、少し待ってopenWindow()を呼ぶ
            setTimeout(() => {
              this.openWindow('/maintenance/company/numbering');
            }, 500);
          }
        );
      }
    });
  }

  /**
   * メニューのパネルを作成する
   * @param menuGroup 業務メニュー
   * @param availabilityInfos サービス可用情報
   * @param isShowDraftExplanatoryNote 下書き伝票件数が表示するかどうか判定するフラグ
   */
  private createBizMenuItems(menuGroup: IBizMenu, availabilityInfos: IServiceAvailabilityInfo[], isShowDraftExplanatoryNote: boolean) {
    const menuList = _filter(
      _orderBy(
        _cloneDeep(menuGroup.businessMenuContentList),
        ['businessMenuPositionX', 'asc'], ['businessMenuPositionY', 'asc']
      ),
      menu => {
        if (menu.businessMenuStatus === BusinessMenuStatus.Hidden) {
          return false;
        }

        // 未契約かつ未導入時表示区分が非表示の場合は除外する
        const availabilityInfo = _find(availabilityInfos, item => item.serviceId === menu.serviceId);
        if (_isNil(availabilityInfo) && menu.bizMenuNotIntroducedDisplayDiv === BizMenuNotIntroducedDisplayDiv.Hidden) {
          return false;
        }

        return true;
      }
    );

    const bizMenuItems: BizMenuItem[] = [];
    let verticalItems: BizMenuContentEx[] = [];
    let lineItems: BizMenuLine[] = [];
    let horizontalIndex = 0;
    const fillItems = item => _isNil(item) ? {} : item;

    // ホリデーアドオン ---Start---
    const isAvailableHdVcleInsp = _some(availabilityInfos, info =>
      info.serviceId === ContractConst.SERVICEID_OPT_MAC_HOLIDAY_INSP
      || info.serviceId === ContractConst.SERVICEID_OPT_MAC_HOLIDAY_BIKE_INSP);
    // ホリデーアドオン ---End---

    menuList.forEach(menu => {

      const menuEx = <BizMenuContentEx>menu;
      if (menuGroup.businessMenuStatus === BusinessMenuStatus.NotSigned) {
        menuEx.businessMenuStatus = BusinessMenuStatus.NotSigned;
        menuEx.serviceId = menuGroup.serviceId;
      }

      // 整備メニューかつコンタクトスケジュールサービス契約済の場合
      if (menuGroup.businessMenuGroupId === this.BUSINESS_MENU_GROUP_ID_SF
        && !!_find(availabilityInfos, info => info.serviceId === ContractConst.SERVICEID_OPT_CMN_CONTACT_SCHEDULE_MAIN)) {
        // 整備メニューの「ご案内」遷移先は「架電一覧」or「DM車検案内」のどちらかで最後に開いた方を優先するので最終案内取得キーを設定しておく
        if (menuEx.businessMenuContentId === this.BUSINESS_MENU_CONTENT_ID_GUIDANCE) {
          menuEx.finalGuidanceKey = Const.Storage.Key.FINAL_GUIDANCE;
          menuEx.productCode = ProductCode.SuperFrontman;
          if (_isEmpty(LocalStorageUtils.get(menuEx.finalGuidanceKey))) {
            // どちらもまだ開いていない場合は「架電一覧」
            LocalStorageUtils.save(menuEx.finalGuidanceKey, PageId.CallList);
          }
        }
      }

      const businessMenuPositionX = Number(menuEx.businessMenuPositionX);
      const businessMenuPositionY = Number(menuEx.businessMenuPositionY);
      // 業務メニュー拡張項目が存在する場合は、バッジを表示する
      if (menuEx.businessMenuExpansionItemList.length !== 0) {
        menuEx.count = {
          key: menuEx.businessMenuExpansionItemList[0],
          value: _get(menuEx.businessMenuExpansionItemList, 1, SlipKind.EstimatesSlip),
        };
      } else if (
        (menuGroup.businessMenuGroupId === BusinessMenuGroupId.PurchaseTab && menuEx.businessMenuContentId === 1) ||
        (menuGroup.businessMenuGroupId === BusinessMenuGroupId.DebtTabRepair && menuEx.businessMenuContentId === 4) ||
        (menuGroup.businessMenuGroupId === BusinessMenuGroupId.DebtTabCarsales && menuEx.businessMenuContentId === 4)
      ) {
        // 仕入伝票入力の設定。データ側で業務メニュー拡張項目の設定をしたらこの処理は不要なので削除する
        menuEx.businessMenuExpansionItemList = ['purchaseSlip'];
        menuEx.count = {
          key: 'purchaseSlip',
          value: 'purchaseSlip',
        };
      } else if (menuGroup.businessMenuGroupId === BusinessMenuGroupId.PurchaseTab && menuEx.businessMenuContentId === 10) {
        // 払出移動伝票の設定。データ側で業務メニュー拡張項目の設定をしたらこの処理は不要なので削除する
        menuEx.businessMenuExpansionItemList = ['payoutMoveSlip'];
        menuEx.count = {
          key: 'payoutMoveSlip',
          value: 'payoutMoveSlip',
        };
      } else if (this.isPartsOrderTab(menuGroup)) {
        if (menuEx.businessMenuContentId === BlPartsOrderMenuContentId.Cart) {
          menuEx.count = {
            key: 'partsOrder',
            value: 'mpCart',
          };
        }

        if (menuEx.businessMenuContentId === BlPartsOrderMenuContentId.Favorite) {
          menuEx.count = {
            key: 'partsOrder',
            value: 'mpFavorite',
          };
        }

        console.log('menuEx.businessMenuContentId', menuEx.businessMenuContentId, BlPartsOrderMenuContentId.Chat);
        if (menuEx.businessMenuContentId === BlPartsOrderMenuContentId.Chat) {
          menuEx.count = {
            key: 'partsOrder',
            value: 'inquiryPartsChat',
          };
        }
      }

      menuEx.isShowDraftSlipCount = isShowDraftExplanatoryNote;
      if (menuGroup.businessMenuGroupId === BusinessMenuGroupId.GlassTabGlass
        && menuEx.serviceId === ContractConst.SERVICEID_OPT_CMN_CREDIT) {
        menuEx.isShowDraftSlipCount = false;
      }

      // ホリデーアドオン ---Start---
      // 接客提案のパネルイラストをホリデー用に変更する
      if (isAvailableHdVcleInsp) {
        if (menuGroup.businessMenuGroupId === this.BUSINESS_MENU_GROUP_ID_SF
          && menuEx.businessMenuContentId === this.BUSINESS_MENU_CONTENT_ID_CONTACT_SCHEDULE) {
          menuEx.businessMenuContentName = 'ホリデー車検';
          menuEx.businessMenuIconCss = 'menu-lane_status_holiday';
        }
      }
      // ホリデーアドオン ---End---

      // 縦軸毎にMenuを分割する
      if (businessMenuPositionX !== horizontalIndex) {
        bizMenuItems[horizontalIndex] = {
          menus: _map(verticalItems, fillItems),
          lines: lineItems,
        };
        horizontalIndex = businessMenuPositionX;
        verticalItems = [];
        lineItems = [];
      }
      for (let i = 0; i <= businessMenuPositionY; i++) {
        if (!lineItems[i]) {
          lineItems[i] = _assign({}, lineItems[i]);
        }
      }
      // 線を作成する
      _forEach(menuEx.businessMenuNextStepList, nextProcess => {
        const nextMenu = _find(menuList, next => next.businessMenuContentId === nextProcess);
        if (!nextMenu) {
          return;
        }
        const nextMenuX = Number(nextMenu.businessMenuPositionX);
        const nextMenuY = Number(nextMenu.businessMenuPositionY);
        // 線が紐づく次のメニューの横軸が同じ場合は、下に線を引く
        if (nextMenuX === businessMenuPositionX) {
          if (!menuEx.lineBottom) {
            menuEx.lineBottom = true;
          }
        } else {
          // 次のメニューが同じ立て軸にない場合は、メニューと同じ位置の右（線エリア上は左）に線を引く
          lineItems[businessMenuPositionY].left = true;
          const differenceX = nextMenuX - businessMenuPositionX;
          // 縦の差分線エリアを作成し縦線を引く
          let yStart = 0, yEnd = 0;
          if (businessMenuPositionY > Number(nextMenuY)) {
            yStart = nextMenuY;
            yEnd = businessMenuPositionY;
          } else {
            yStart = businessMenuPositionY;
            yEnd = nextMenuY;
          }
          for (let yIndex = yStart; yIndex < yEnd; yIndex++) {
            lineItems[yIndex] = _assign({}, lineItems[yIndex], {
              bottom: true,
            });
          }
          // 次のメニューと同じ位置の左（線エリア上は右）に線を引く
          lineItems[nextMenuY] = _assign({}, lineItems[nextMenuY], {
            right: true,
          });
          if (differenceX > 0) {
            // 次のメニューの横軸が隣接していない場合は、styleで線を伸ばす
            const width = `((50% + 100px) * ${differenceX - 1})`;
            lineItems[nextMenuY].rightStyle = {
              right: this.sanitizer.bypassSecurityTrustStyle(`calc(-1 * ${width})`),
              width: this.sanitizer.bypassSecurityTrustStyle(`calc(50% + ${width})`),
            };
          }
        }
      });
      verticalItems[businessMenuPositionY] = menuEx;
    });

    bizMenuItems[horizontalIndex] = {
      menus: _map(verticalItems, fillItems),
      lines: lineItems,
    };

    _forEach(bizMenuItems, bizMenuItem => {
      _forEach(bizMenuItem.menus, menuEx => {
        const relationMenus = _filter(bizMenuItem.menus, val => {
          return !_isNil(val) && _indexOf(menuEx.businessMenuNextStepList, val.businessMenuContentId) !== -1;
        });

        const maxRelationMenu = _maxBy(relationMenus, 'businessMenuPositionY');
        if (!_isNil(maxRelationMenu) && maxRelationMenu.businessMenuPositionY > menuEx.businessMenuPositionY) {
          for (let yIndex = menuEx.businessMenuPositionY; yIndex < maxRelationMenu.businessMenuPositionY; yIndex++) {
            bizMenuItem.menus[yIndex].lineBottom = true;
          }

          const minRelationMenu = _minBy(relationMenus, 'businessMenuPositionY');
          if (
            minRelationMenu.businessMenuPositionY !== maxRelationMenu.businessMenuPositionY
            && minRelationMenu.businessMenuPositionY < menuEx.businessMenuPositionY
          ) {
            for (let yIndex = minRelationMenu.businessMenuPositionY; yIndex < menuEx.businessMenuPositionY; yIndex++) {
              bizMenuItem.menus[yIndex].lineBottom = true;
            }
          }
        }
      });
    });

    return bizMenuItems;
  }

  /**
   * サービスIDをプロダクトコードに変換します。
   * @param serviceId サービスID
   * @returns プロダクトコード
   */
  private serviceIdToProductCode(serviceId: string): string {
    switch (serviceId) {
      case ContractConst.SERVICEID_PRODUCT_MAINTENANCE:
        return ProductCode.SuperFrontman;
      case ContractConst.SERVICEID_PRODUCT_REPAIR:
        return ProductCode.Repair;
      case ContractConst.SERVICEID_PRODUCT_PARTSMAN:
        return ProductCode.Partsman;
      case ContractConst.SERVICEID_PRODUCT_RECYCLE:
        return ProductCode.Recycle;
      case ContractConst.SERVICEID_PRODUCT_GLASS:
        return ProductCode.Glass;
      case ContractConst.SERVICEID_OPT_CMN_CARSALES_ESTIMATE_ORDER:
      case ContractConst.SERVICEID_OPT_CMN_CARSALES_VEHICLESTOCK:
      case ContractConst.SERVICEID_OPT_CMN_CARSALES_PURCHASE:
        return ProductCode.CarSales;
      case ContractConst.SERVICEID_PRODUCT_LOGISTICS:
        return ProductCode.DeliveryPf;
    }
    return null;
  }


  /**
   * 単体版の契約か確認する
   * @param serviceIdList 契約中の基本サービスID一覧
   * @param targetServiceId チェック対象のサービスID一覧
   */
  private isSingleProductAvailable(serviceIdList: string[], target: string | string[]) {
    if (_isEmpty(serviceIdList) || serviceIdList.length !== 1 || _isEmpty(target)) {
      return false;
    }

    const targetList = _isArray(target) ? target : [target];
    return _some(targetList, id => id === serviceIdList[0]);
  }

  /**
   * 指定されたサービスIDリストに基づき、利用可能なメンテナンス関連のプロダクトコード一覧を取得します
   * @param serviceIdList 契約中の基本サービスID一覧
   * @returns 利用可能なメンテナンスプロダクトコードの配列
   */
  private getAvailableMaintenanceProducts(serviceIdList: string[]): string[] {
    // メンテナンスプロダクトコードと、それが有効になるために必要なサービスIDのマッピング
    const requiredServiceIds: Record<string, string[]> = {
      // 整備に必要なサービスID
      [ProductCode.SuperFrontman]: [ContractConst.SERVICEID_PRODUCT_MAINTENANCE],
      // 鈑金に必要なサービスID
      [ProductCode.Repair]: [ContractConst.SERVICEID_PRODUCT_REPAIR],
      // 車販に必要なサービスID
      [ProductCode.CarSales]: [ContractConst.SERVICEID_OPT_CMN_CARSALES_ESTIMATE_ORDER]
    };

    // マッピングに基づいて、利用可能なプロダクトコードのみをフィルタリングして返す
    return Object.entries(requiredServiceIds)
      .filter(([productCode, neededServiceIds]) => {
        // --- 基本条件: 必要なサービスIDが存在するか ---
        const hasRequiredService = _some(
          neededServiceIds,
          neededId => _some(serviceIdList, id => id === neededId)
        );

        // --- 特別な条件: 対応するタブが存在するかどうかを判定 ---
        // どのプロダクトも、(サービスの契約) AND (UI上にタブが表示されている) をチェックする
        if (
          ProductCode.SuperFrontman === productCode ||
          ProductCode.Repair === productCode ||
          ProductCode.CarSales === productCode
        ) {
          // 汎用メソッドを使って、該当プロダクトのタブが存在するか確認
          return hasRequiredService && this.hasAvailableTabForProduct(productCode);
        }

        return hasRequiredService;
      })
      .map(([productCode]) => productCode);
  }

  /**
   * 指定されたプロダクトコードを持つ、利用可能なタブが存在するかを判定する
   * @param productCode 判定したいプロダクトコード (e.g., ProductCode.CarSales)
   * @returns {boolean} 利用可能なタブが存在すればtrue、なければfalse
   */
  private hasAvailableTabForProduct(productCode: string): boolean {
    // tabOptionsが存在する場合のみ判定を行う
    if (this.tabOptions) {
      return this.tabOptions.some(tabOption =>
        // 引数で渡されたプロダクトコードと一致すること
        productCode === tabOption.productCode &&
        tabOption.menuGroup && tabOption.menuGroup.businessMenuStatus === BusinessMenuStatus.Available
      );
    }
    // tabOptionsが存在しない場合はfalseを返す
    return false;
  }

  /**
   * サービス状態変更イベントハンドラ
   * @param serviceId サービスID
   * @param isAvailable 状態
   */
  onChangeServiceState(serviceId: string, isAvailable: boolean) {
    if (this._isAvailableService[serviceId] !== isAvailable) {
      this._isAvailableService[serviceId] = isAvailable;
    }
  }

  /**
   * 売上目標進捗ボタンクリックイベントハンドラ
   */
  onClickMngAnalysisResult() {
    const mngUrl = '/managementreport/display';
    window.open(mngUrl, '_blank');
  }

  /**
   * 目標管理ボタンクリックイベントハンドラ
   */
  onClickMokuhyoMngAnalysis() {
    let mngUrl = '/maintenance/analysis/sfsalesgoal';
    switch (this.currentTabId) {
      case '1':
        mngUrl = '/maintenance/analysis/sfsalesgoal';
        break;
      case '3':
        mngUrl = '/maintenance/analysis/repairsalesgoal';
        break;
      case '5':
        mngUrl = '/maintenance/company/salesgoalsettings';
        break;
      default:
        if (this._isAvailableBiToolPm) {
          mngUrl = '/maintenance/company/salesgoalsettings';
        }
        break;
    }
    window.open(mngUrl, '_blank');
  }

  /**
   * 詳細分析ボタンクリックイベントハンドラ
   */
  onClickDetailAnalysis() {
    this.pageService.getTenlantTaskStatus().subscribe(
      res => {
        const mngUrl = '/managementreport/detail-analysis';
        if (res.length > 0) {
          const taskStatus = res[0].biTaskRunStatusDiv;
          switch (taskStatus) {
            case BiTaskRunStatus.None.code:
            case BiTaskRunStatus.Waiting.code:
            case BiTaskRunStatus.Starting.code:
            case BiTaskRunStatus.Running.code:
              const runningService = res[0].biTaskServiceId ? res[0].biTaskServiceId.split('_') : [];
              this.pageService.getDetailAnalysisServiceIds().subscribe(
                availableService => {
                  const difference = _difference(availableService, runningService);
                  if (difference.length > 0) {
                    window.open(mngUrl, '_blank');
                  } else {
                    this.showBiToolTaskInitMessage();
                  }
                }
              );
              break;
            case BiTaskRunStatus.Finished.code:
              window.open(mngUrl, '_blank');
          }
        } else {
          window.open(mngUrl, '_blank');
        }
      },
    );
  }

  /**
   * 初期設定実行メッセージを表示します。
   */
  private showBiToolTaskInitMessage() {
    this.dialogService.info('初期設定実行中です。時間をおいて再度お試しください。').subscribe((ref: BlModalRef) => {
      ref.hide();
    });
  }

  /*
   * 社内連絡の表示制御のロールを取得
   */
  private isAvailableInternalContactDispRole(): Observable<boolean> {
    return this.loginResourceService.isAvailableFunction(RoleConst.ROLEID_FUNC_ALL_INTERNAL_CONTACT_DISP);
  }

  /*
   * 仕入在庫帳票の表示制御のロールを取得
   */
  private isAvailablePurchaseStockReport(): Observable<boolean> {
    return this.loginResourceService.isAvailableFunction(RoleConst.ROLEID_MENU_SFC_PURCHASESTOCK_REPORT);
  }

  /**
   * 有効期限に表示するフォーマットに変換
   * @param date 日時
   * @returns dateから28日後の日時
   */
  private getExpirationDate(date: string): string {
    if (date) {
      return DateTimeUtils.format(
        DateTimeUtils.addDays(DateTimeUtils.parseDate(date), 28),
        DateTimeOutput.YMD,
        DateTimePadding.ZERO,
        DateSeparator.JP
      );
    } else {
      return '';
    }
  }

  /***
   * タブ領域の表示制御するアコーディオンコンテンツの表示制御
   */
  private showNavTabsAccordionContent() {
    if (this._multiStage === BlTabMultiStage.MultiStage) {
      const heightRange = 38;
      let navTabsHeight = heightRange;
      try {
        navTabsHeight = document.querySelector('div.nav.nav-tabs').getBoundingClientRect().height;
      } catch (error) {
        // タブ領域が非表示である場合、エラー発生を握りつぶす。
      }
      if (navTabsHeight > heightRange) {
        this.showAccordionContentFlg = true;
      } else {
        this.showAccordionContentFlg = false;
        if (this._isHideTabNavItem) {
          // タブ領域が非表示である場合、アコーディオンを押下する
          this.onClickNavTabsExpand();
        }
      }
    }
  }

  /**
   * 通知案内を表示します。
   */
  private showNotificationGuide() {
    // ログイン後初回フラグを取得
    const initAfterLogin = this.pageService.loadLocalStorageInitAfterLogin();

    // ログイン後初回のみ通知案内を表示
    if (initAfterLogin) {
      this.pageService.getNotificationGuide().subscribe(
        notifications => {
          if (!_isEmpty(notifications)) {
            _forEach(notifications, n => {
              this.dialogService.info(n.notificationContent, n.notificationTitle).subscribe(
                dialogRef => dialogRef.hide()
              );
            });
          }
        }
      );

      // アラート通知の表示
      this.pageService.getNotificationGuideForAlert().subscribe(
        notifications => {
          if (!_isEmpty(notifications)) {
            // 通知レベルが Critical > Alertの優先度で、表示する通知を1件選定する
            // 同じ通知レベルのデータが複数取得された場合、通知メッセージ.通知送信日時 が1番新しい1件を選定する（※API呼び出し時にソート）
            let targetNotification = _find(notifications, n => n.notificationLevel === NotificationLevel.Critical);

            // Criticalが見つからなかった場合のみAlertを探す
            if (_isNil(targetNotification)) {
              targetNotification = _find(notifications, n => n.notificationLevel === NotificationLevel.Alert);
            }

            // 表示対象の通知が見つかった場合（CriticalまたはAlertの場合）のみ処理を実行
            if (!_isNil(targetNotification)) {
              let alertType;
              switch (targetNotification.notificationLevel) {
                case NotificationLevel.Alert:
                  alertType = this.AlertType.warn;
                  break;
                case NotificationLevel.Critical:
                  alertType = this.AlertType.critical;
                  break;
                default:
                  // Alert または Critical 以外は alertType に値を設定しない（処理をスキップする）
                  break;
              }

              if (alertType !== undefined) {
                this.overlayAlertService.show({
                  show: true,
                  title: targetNotification.notificationTitle,
                  message: targetNotification.notificationContent,
                  type: alertType
                });
              }
            }
          }
        }
      );

      // ログイン後初回フラグを削除
      this.pageService.removeLocalStorageInitAfterLogin();
    }
  }

  /**
   * 受発注のバッジデータ取得
   */
  private getPartsOrderCount() {
    this.badge.partsOrder = {
      mpCart: { final: 0, draft: 0 },
      mpFavorite: { final: 0, draft: 0},
      inquiryPartsChat: { final: -1, draft: -1 },
    };
    this.existBadge.partsOrder = {
      mpCart: false,
      mpFavorite: false,
      inquiryPartsChat: true,
    };

    ObservableForkJoin([
      this.hasPsUserCode ? this.pageService.getNotPurchasedParts() : ObservableOf(0), // PSユーザーコードがないなら表示は不要なので0件扱いとする
      this.pageService.getMPFavoriteCount(),
      this.pageService.getUnreadInquiryPartsChatCount(this.organizationCode)
    ]).subscribe(
      ([notPurchasedPartsCount, favoriteCount, unreadInquiryPartsChatCount]) => {
        // draftは-1にすることで非表示にする
        this.badge.partsOrder = {
          mpCart: { final: notPurchasedPartsCount, draft: -1 },
          mpFavorite: { final: favoriteCount, draft: -1 },
          inquiryPartsChat: { final: unreadInquiryPartsChatCount > 0 ? unreadInquiryPartsChatCount : -1, draft: -1 },
        };

        this.existBadge.partsOrder = {
          mpCart: !!notPurchasedPartsCount,
          mpFavorite: !!favoriteCount,
          inquiryPartsChat: true,
        };

        this.pageService.notifyNotPurchasedParts(notPurchasedPartsCount);
      },
      () => { },
      () => {
        if (this.timer.partsOrder) {
          clearTimeout(this.timer.partsOrder);
        }
        this.timer.partsOrder = setTimeout(() => {
          this.getPartsOrderCount();
        }, this.badgeInterval);
      }
    );
  }

  /**
   * 受発注タブである
   * * 受発注タブとリサイクルタブのbusinessMenuGroupIdが同値になっているため専用のチェックを作成
   */
  private isPartsOrderTab(menuGroup: IBizMenu) {
    return (
      menuGroup.businessMenuGroupId === BusinessMenuGroupId.PartsOrder && // タブ判定
      menuGroup.serviceId === ContractConst.SERVICEID_OPT_CMN_BLORDER_BASE
    );
  }

  /**
   * 画面動作設定取得
   */
  private fetchScreenActionSetting() {
    this.screenActionSettingService.fetch().subscribe({
      next: (screenActionSetting) => {
        this.screenActionSetting = screenActionSetting;
      },
      error: (err) => {
        console.error('画面動作設定の取得に失敗しました。', err);
      }
    });
  }

  /**
   * カスタム設定バブルメニューを表示します。
   * @param functionRef ファンクション管理クラス
   */
  private showCustomSettingBubble(functionRef: FunctionRef) {
    // カスタム設定バブルメニュー
    const bubbleMenus: any[] = [
      FnKey.BubbleFn1.setLabel(ButtonLabels.DISPLAY_SETTING).setRole(BubbleFnRole.ScreenActionSetting)
    ];

    // タジマオプションが有効の場合、カスタム設定バブルメニューに「一新多助設定」を追加
    if (this.isAvailableTajima) {
      if (
        _isEqual(this.currentTab.productCode, ProductCode.SuperFrontman) ||
        _isEqual(this.currentTab.productCode, ProductCode.Repair) ||
        _isEqual(this.currentTab.productCode, ProductCode.CarSales)
      ) {
        bubbleMenus.push(FnKey.BubbleFn8.setLabel(ButtonLabels.ISSHIN_TASUKE_SETTING).setRole(BubbleFnRole.IsshinTasukeSetting));
      }
    }

    functionRef.showBubble(bubbleMenus).subscribe(
      (bubbleFunctionRef: FunctionRef) => {
        switch (<number>bubbleFunctionRef.role) {
          // 画面動作設定
          case BubbleFnRole.ScreenActionSetting:
            this.functionScreenActionSetting(bubbleFunctionRef);
            break;

          case BubbleFnRole.IsshinTasukeSetting:
            this.functionIsshinTasukeSetting(bubbleFunctionRef);
            break;
        }
        bubbleFunctionRef.end(false, true);
      }
    );
    functionRef.end();
  }

  /**
   * 画面動作設定バブルメニュー選択検知
   * @param functionRef ファンクション情報管理
   */
  private functionScreenActionSetting(functionRef?: FunctionRef) {
    this.loginResourceService
      .getAllServiceAvailabilityInfo()
      .pipe(
        map((response) => {
          if (!_includes(this.maintenanceProductArr, ProductCode.Repair)) {
            return this.maintenanceProductArr;
          }

          // 鈑金の見積りサービスがない場合は、鈑金のプロダクトコードを除外し、画面動作設定モーダルから鈑金項を表示しない。
          const availabilities = _compact(_map(response, (availability) => availability.serviceId));
          const hasRepairSlipService = this.hasRepairEstimateServices(availabilities);
          return hasRepairSlipService
            ? this.maintenanceProductArr
            : this.maintenanceProductArr.filter((productCode) => productCode !== ProductCode.Repair);
        }),
        switchMap((productCodeList) => {
          const screenActionSettingModalOption: ModalOption = {
            data: {
              productCodeList,
              screenActionSetting: this.screenActionSetting,
              isCaseEvidenceAutoRegistAvailable: this.isCaseEvidenceAutoRegistAvailable
            },
          };

          return this.modalService.show(BizMenuPageScreenActionSettingModalComponent, screenActionSettingModalOption);
        })
      )
      .subscribe((modalRef) => {
        modalRef.hide();
        if (modalRef.reason === ModalReason.Done) {
          const result = modalRef.getResults();
          this.screenActionSettingService.save(result).subscribe(
            () => {
              this.screenActionSetting = result;
            },
            () => {
              // 業務を続行できるようにメッセージ表示して例外スルー
              this.dialogService.info('画面動作設定の変更に失敗しました。').subscribe(
                dialogRef => {
                  dialogRef.hide();
                }
              );
            }
          );
        }
      }
    );

    if (functionRef) {
      functionRef.end(false, true);
    }
  }

  /**
   * 一新多助設定バブルメニュー選択検知
   * @param functionRef ファンクション情報管理
   */
  private functionIsshinTasukeSetting(functionRef?: FunctionRef) {
    // 一新多助のメニュー設定を表示
    this.showIsshinTasukeMenuSetting();

    if (functionRef) {
      functionRef.end(false, true);
    }
  }

  /**
   * 指定されたページIDがメンテナンス対象画面かどうかを判定する
   * @param {PageId} pageId 判定対象のページID
   * @returns {boolean} メンテナンス対象の場合は true、それ以外は false
   */
  private isMaintenance(pageId: PageId): boolean {
    return MAINTENANCE_TARGET_PAGE_IDS.some(id => id === pageId);
  }

  /**
   * カスタム設定Fn表示判定
   * 鈑金の場合、見積りサービスが利用可能ならtrue、鈑金以外の阿合、常にtrueを返却する。
   * @param pageId 判定対象のページID
   * @param availabilities 利用可能なサービスID配列
   * @returns カスタム設定Fn表示有無
   */
  private hasRequiredRepairEstimateServices(pageId: PageId, availabilities: string[]): boolean {
    return pageId !== PageId.MenuRepairBiz || this.hasRepairEstimateServices(availabilities);
  }

  /**
   * 指定されたプロダクトコードと設定に基づき、遷移先のURLを動的に決定します
   * このメソッドは、特定のプロダクト（SuperFrontman, Repair, CarSales）でのみ動作します
   * @param currentProductCode - 現在のプロダクトコード
   * @param screenActionSetting - 画面のアクション設定オブジェクト
   * @param url - 元のURL（フォールバックとして使用される）
   * @param menu - メニューコンテキスト情報。受付または伝票種別の判定に使用されます
   * @returns {string} - 条件に一致した場合はルールに基づくURL、それ以外の場合は元のURL
   */
  private getTargetUrl(
    currentProductCode: string,
    screenActionSetting: IBizMenuPageScreenActionSetting,
    url: string,
    menu: BizMenuContentEx
  ): string {
    // 1. 特別なロジックが適用されないプロダクトの場合は、元のURLを直接返します
    if (ProductCode.SuperFrontman !== currentProductCode &&
      ProductCode.Repair !== currentProductCode &&
      ProductCode.CarSales !== currentProductCode) {
      return url;
    }

    // 受付一覧は証跡帳票自動登録サービスが利用可能な場合だけ許可し、無効時は保存値を残したまま既存導線へ戻す。
    // 業務メニューコンテンツIDの採番ルールに基づき、整備・鈑金グループではcontentId=1が受付を表す。
    if (
      menu &&
      (currentProductCode === ProductCode.SuperFrontman ||
        currentProductCode === ProductCode.Repair) &&
      menu.businessMenuContentId === MaintenanceRepairMenuContentId.Reception
    ) {
      if (!this.isCaseEvidenceAutoRegistAvailable) {
        return url;
      }
      const receptionSettingPath = currentProductCode === ProductCode.SuperFrontman
        ? ['reception', 'sf']
        : currentProductCode === ProductCode.Repair ? ['reception', 'repair'] : undefined;
      const receptionNavigationDiv = receptionSettingPath
        ? _get(screenActionSetting, receptionSettingPath)
        : undefined;
      return receptionNavigationDiv === ReceptionNavigationDiv.ReceptionList
        ? PagePath.ReceptionList
        : url;
    }

    // 2. 特定の伝票検索画面以外は、URLを変更しないため早期に抜けます
    if (!url.startsWith(SLIP_SEARCH_URL_PATHS.SALESSLIP_SEARCH) &&
      !url.startsWith(SLIP_SEARCH_URL_PATHS.CAR_SALES_SLIP_SEARCH)) {
      return url;
    }
    // 3. 設定から、現在のプロダクトと伝票種別に対応するルールを取得します
    const rulesForProduct = DIV_LOOKUP_CONFIG[currentProductCode];
    if (!rulesForProduct) {
      // プロダクトが設定に定義されていない場合は、元のURLを返します
      return url;
    }
    let slipKind: string;
    if (menu && menu.count) {
      // 現在のプロダクトの伝票種別を取得する
      slipKind = menu.count.value;
    }
    const lookupRule = rulesForProduct[slipKind];
    if (!lookupRule) {
      // 伝票種別がプロダクトのルールに定義されていない場合も、元のURLを返します
      return url;
    }
    // 4. 取得したルールを使用して、screenActionSettingをチェックします
    const { settingProperty, expectedDiv } = lookupRule;
    if (!screenActionSetting || !expectedDiv) {
      // screenActionSetting または expectedDiv が無効な場合、現在の URL を返して処理を中断する
      return url;
    }
    const currentDivValue = _get(screenActionSetting, settingProperty);
    if (currentDivValue === expectedDiv.value) {
      // 条件に一致した場合、ナビゲーションルールから最終的なURLを検索します
      const finalRules = NAVIGATION_RULES[currentProductCode];
      // expectedDivが遷移先のDIV（画面識別子）です
      if (finalRules && finalRules[expectedDiv.name] !== undefined) {
        const targetPath = finalRules[expectedDiv.name];
        const targetProperty = Array.isArray(settingProperty) && settingProperty.length > 1 ? settingProperty[1] : '';
        // slipKindは既に取得済みなので、それを渡します
        const finalUrlWithQuery = this.buildUrlWithQuery(currentProductCode, targetPath, slipKind, targetProperty);
        // buildUrlWithQueryがURLを生成できた場合
        if (finalUrlWithQuery) {
          return finalUrlWithQuery;
        }
      }
    }
    // 5. 上記のいずれの条件にも一致しない場合は、元のURLを返します
    return url;
  }

  /**
   * プロダクトコードに応じてクエリパラメータを付与したURLを生成する
   * @param productCode プロダクトコード
   * @param baseUrl 元となるURL
   * @param slipKind 伝票種別
   * @param settingProperty screenActionSettingプロパティ名
   * @returns クエリパラメータ付きURL、または未定義の場合はnull
   */
  private buildUrlWithQuery(
    productCode: string,
    baseUrl: string,
    slipKind?: string,
    settingProperty?: string
  ): string | null {
    let keyQuery: { [key: string]: string } = {};
    switch (productCode) {
      // 整備
      case ProductCode.SuperFrontman:
        keyQuery = {
          // 業務セッションクリアフラグ
          [BlUrlQueryKey.ClearBsid]: '1',
          // 伝票種別
          [BlUrlQueryKey.SlipKind]: slipKind,
          // 顧客車両検索表示区分
          [BlUrlQueryKey.CustomerVehicleSearchDispDiv]: CustomerVehicleSearchDispDiv.SfSlip.toString(),
          // 顧客車両検索画面で、整備伝票一覧のみを検索できるよう、URLクエリにプロダクトコード「整備」を設定
          [BlUrlQueryKey.ProductCode]: ProductCode.SuperFrontman,
        };
        break;
      // 鈑金
      case ProductCode.Repair:
        keyQuery = {
          // 業務セッションクリアフラグ
          [BlUrlQueryKey.ClearBsid]: '1',
          // 伝票種別
          [BlUrlQueryKey.SlipKind]: slipKind,
        };
        break;
      // 車販
      case ProductCode.CarSales:
        // 見積り場合
        if (settingProperty === SLIP_NAVIGATION_PROPERTY.ESTIMATES_SLIP) {
          keyQuery = {
            // 業務セッションクリアフラグ
            [BlUrlQueryKey.ClearBsid]: '1',
            // 伝票種別
            [BlUrlQueryKey.SlipKind]: slipKind,
          };
        } else {
          keyQuery = {
            // 顧客車両検索表示区分
            [BlUrlQueryKey.CustomerVehicleSearchDispDiv]: CustomerVehicleSearchDispDiv.CarSalesSlip.toString(),
            // 伝票種別
            [BlUrlQueryKey.SlipKind]: slipKind,
          };
        }
        break;
      default:
        // 該当しないプロダクトの場合は、クエリなしで返す
        return baseUrl;
    }

    const query = new BlUrlQuery(convertToParamMap(keyQuery));
    return `${baseUrl}?${query.getQueryString()}`;
  }

  /**
   * 追加帳票出力バブルメニュー選択イベントハンドラ
   * @param functionRef ファンクション情報管理クラス
   */
  private onSelectedPDFBubbleMenu(functionRef: FunctionRef) {
    switch (<number>functionRef.role) {
      // PDF出力状況
      case FunctionRole.BubbleFn2:
        this.showExportStatusGuide();
        functionRef.end();
        break;
      // PDF出力
      case FunctionRole.BubbleFn3:
        this.export();
        functionRef.end();
        break;
      // 並び順設定
      case FunctionRole.BubbleFn4:
        this.showExportPatternModal();
        functionRef.end();
        break;
      default:
        functionRef.end();
        break;
    }
  }

  /**
   * 出力状況ボタンの押下処理
   */
  public showExportStatusGuide() {
    // 画面ID
    let pageId = [
      PageId.MenuDepositAndBilling + '-Pm',
      PageId.MenuDepositAndBilling + '-Pm-1'
    ];
    if (this.currentTabId === String(BusinessMenuGroupId.DebtTabPartsman)) {
      pageId = [
        PageId.MenuWithdrawalAndPayment + '-Pm',
        PageId.MenuWithdrawalAndPayment + '-Pm-1',
        PageId.MenuWithdrawalAndPayment + '-Pm-2',
        PageId.MenuWithdrawalAndPayment + '-Pm-3'
      ];
    }
    const conditions: BlConditionInfo[] = [
      {
        key: 'reportCreateDateTime',
        value: DateTimeUtils.formatIso(DateTimeUtils.today()),
        type: BlConditionType.GreaterThanEqual,
      }
    ];
    this.modalService.show(ReportOutputStatusGuideComponent, {
      data: {
        addPageId: true,
        useStatusFilter: true,
        pageId: pageId,
        conditions: conditions,
        downloadFlg: true,
        showTotalCount: true,
        targetRangeDisplay: true,
      },
      size: ModalSize.Xlarge,
    }).subscribe((modalRef) => {
      modalRef.hide();
    });
  }

  /**
   * データ出力
   */
  export() {
    if (this.currentTabId === String(BusinessMenuGroupId.CreditTabPartsman)) {
      this.pageService.export('credit');
    } else if (this.currentTabId === String(BusinessMenuGroupId.DebtTabPartsman)) {
      this.pageService.export('debt');
    }
  }

  /**
   * データ出力ボタンの押下処理
   */
  showExportPatternModal() {
    this.getSelectExportPattern();
    this.updateExportPatternItems();

    let exportInfoDiv = ExportInfoDiv.BillingAccRecBalList;
    let exportPatternCode = ExportPatternCodeConstant.PATTERN_CODE_ALL_ITEM_BILLING;

    if (this.currentTabId === String(BusinessMenuGroupId.DebtTabPartsman)) {
      exportInfoDiv = ExportInfoDiv.AccPayBalanceList;
      exportPatternCode = ExportPatternCodeConstant.PATTERN_CODE_ALL_ITEM_PAY;
    }
    const data: IExportPatternModalParams = {
      exportInfoTabDiv: this.exportInfoTabDiv,
      exportInfoDiv: exportInfoDiv,
      exportPatternCode: exportPatternCode,
      dataModalExportPatterns: this._exportPatternItems,
    };
    // 出力並び順設定モーダル画面で情報変更通知
    let isUpdateOrCreateNewPattern = false;

    const subscription = this.modalService.show(ExportPatternModalComponent, { data }).subscribe(
      modalRef => {
        switch (modalRef.reason) {
          case ModalReason.Cancel:
          case ModalReason.Esc:
          case ModalReason.BackdropClick:
            // 出力並び順設定モーダル画面で変更有無処理
            if (isUpdateOrCreateNewPattern) {
              _delay(() => {
                this.updateExportPatternItems();
                this.loadingService.hide();
                modalRef.hide();
                subscription.unsubscribe();
              }, 1000);
            } else {
              // 出力並び順設定モーダル画面で情報を変更しない場合、モーダル画面を閉じる
              modalRef.hide();
              subscription.unsubscribe();
            }
            break;
          case ModalReason.Done:
          case ModalReason.Any:
            isUpdateOrCreateNewPattern = true;
            break;
          default:
            break;
        }
      }
    );
  }


  /**
   * 出力パターン項目リストを更新します。
   */
  private updateExportPatternItems() {
    let exportInfoDiv = ExportInfoDiv.BillingAccRecBalList;
    let exportPatternCode = ExportPatternCodeConstant.PATTERN_CODE_ALL_ITEM_BILLING;

    if (this.currentTabId === String(BusinessMenuGroupId.DebtTabPartsman)) {
      exportInfoDiv = ExportInfoDiv.AccPayBalanceList;
      exportPatternCode = ExportPatternCodeConstant.PATTERN_CODE_ALL_ITEM_PAY;
    }
    this.pageService
      .getExportPatternInfo(
        this.exportInfoTabDiv,
        exportInfoDiv,
        ExportWorkTypeDiv.MainWorkType,
        exportPatternCode
      )
      .subscribe((items) => {
        if (!_isEmpty(items)) {
          this._exportPatternItems = items[0];
          // 出力パターンの選択情報をローカルストレージに保存
          this.selectExportPatterns[exportInfoDiv] = this._exportPatternItems.exportPatternCode;
          this.pageService.saveExportPatternLocalStorage(
            this.loginUser.blTenantId, this.loginUser.blUserId, this.exportInfoTabDiv, this.selectExportPatterns
          );
        }
      }
    );
  }

  /**
   * 出力パターン選択情報を取得します。
   */
  private getSelectExportPattern() {
    if (!this.loginUser) {
      return;
    }
    const exportInfoTabDiv = ExportInfoTabDiv.Excluded;
    // 出力パターン選択情報をローカルストレージから取得
    this.selectExportPatterns = this.pageService.getExportPatternLocalStorage(
      this.loginUser.blTenantId, this.loginUser.blUserId, exportInfoTabDiv
    );
  }

  /**
   * 鈑金の見積りサービス利用判定
   * @param availabilities 利用可能なサービスID配列
   * @returns 利用可否 true:利用可能, false:利用不可
   */
  private hasRepairEstimateServices(availabilities: string[]): boolean {
    return _some(REPAIR_SLIP_SERVICE_IDS, id => _includes(availabilities, id));
  }

  /**
   * 一新多助メニュークリックイベントハンドラ
   * @param bizMenuContent 業務メニューコンテンツ
   */
  onClickIsshinTasukeMenu(bizMenuContent: BizMenuContentEx) {
    this.onNext(bizMenuContent);
  }

  /**
   * 一新多助タブオプションを設定します。
   * @param setting 一新多助メニュー設定
   */
  private setIsshinTasukeTabOption(setting: IIsshinTasukeMenuSetting) {
    this.tabOptions = [];

    // 一新多助タブオプション
    const isshinTasukeTabOption = _cloneDeep(IsshinTasukeTabOption);

    // すべて表示または単独表示であれば一新多助メニュータブを追加
    if (
      setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.All ||
      setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.Only
    ) {
      this.tabOptions.push(isshinTasukeTabOption);
    }

    // すべて表示であれば通常タブを追加
    if (
      setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.All ||
      setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.Hide
    ) {
      this.tabOptions.push(...this.tabOptionsBackup);
    }

    // 単独表示またはすべて表示で一新多助メニュータブをデフォルト表示の場合、一新多助メニュータブをアクティブ
    if (
      setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.Only ||
      (
        setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.All &&
        setting.isshinTasukeBusinessTabDefaultDiv === IsshinTasukeBusinessTabDefaultDiv.IsshinTasuke
      )
    ) {
      isshinTasukeTabOption.defaultActive = true;
    } else {
      isshinTasukeTabOption.defaultActive = false;
      this.tabOptionsBackup[0].defaultActive = true;
    }
  }

  /**
   * 一新多助メモクリックイベントハンドラ
   */
  onClickIsshinTasukeMemo() {
    this.showIsshinTasukeMenuSetting(true);
  }

  /**
   * 一新多助メニュー設定を表示します。
   * @param memoFocusFlag メモ欄初期フォーカスフラグ
   */
  private showIsshinTasukeMenuSetting(memoFocusFlag = false) {
    ObservableForkJoin(
      this.isshinTasukeMenuService.getIsshinTasukeMenuSetting(this.loginUser.blUserId!),
      this.isshinTasukeMenuService.getIsshinTasukeMenuSettingRules()
    ).subscribe(
      ([entity, rules]) => {
        // 編集モード
        const editMode = entity.blUserId ? EditMode.Edit : EditMode.Add;

        // プロダクトコード
        const productCodeList: string[] = _filter(this.tabOptionsBackup,
          tab => (
            (tab.productCode === ProductCode.SuperFrontman && this.isPermissionMaintenance()) ||
            (tab.productCode === ProductCode.Repair && this.isPermissionRepair()) ||
            (tab.productCode === ProductCode.CarSales && this.isPermissionCarsales())
          )
        ).map(tab => tab.productCode);

        // BL利用者
        entity.blUserId = this.loginUser.blUserId;

        // 共通メニューリストの提供データを除外
        if (entity.isshinTasukeCommonMenuGroup) {
          entity.isshinTasukeCommonMenuGroup.isshinTasukeMenuContentList = _filter(
            entity.isshinTasukeCommonMenuGroup.isshinTasukeMenuContentList,
            menu => menu.offerUserDataDiv !== OfferUserDataDiv.Offer
          );
        }

        // 整備、鈑金、車販メニューリストの無効メニューを除外
        if (entity.isshinTasukeMaintenanceMenuGroup) {
          entity.isshinTasukeMaintenanceMenuGroup.isshinTasukeMenuContentList = _map(
            entity.isshinTasukeMaintenanceMenuGroup.isshinTasukeMenuContentList,
            menu => this.isValidBusinessMenu(menu) ? menu : {
              businessMenuGroupId: 0,
              businessMenuContentId: 0,
              businessMenuContentName: ''
            }
          );
        }
        if (entity.isshinTasukeRepairMenuGroup) {
          entity.isshinTasukeRepairMenuGroup.isshinTasukeMenuContentList = _map(
            entity.isshinTasukeRepairMenuGroup.isshinTasukeMenuContentList,
            menu => this.isValidBusinessMenu(menu) ? menu : {
              businessMenuGroupId: 0,
              businessMenuContentId: 0,
              businessMenuContentName: ''
            }
          );
        }
        if (entity.isshinTasukeCarsalesMenuGroup) {
          entity.isshinTasukeCarsalesMenuGroup.isshinTasukeMenuContentList = _map(
            entity.isshinTasukeCarsalesMenuGroup.isshinTasukeMenuContentList,
            menu => {
              if (this.isValidBusinessMenu(menu)) {
                return menu;
              } else {
                menu.businessMenuGroupId = 29;
                return this.isValidBusinessMenu(menu) ? menu : {
                  businessMenuGroupId: 0,
                  businessMenuContentId: 0,
                  businessMenuContentName: ''
                };
              }
            }
          );
        }

        const data = {
          entity,
          rules,
          editMode,
          groupList: this.businessGroupList,
          allMenuList: this.businessAllMenuList,
          memoFocusFlag,
          productCodeList
        };

        this.modalService.show(IsshinTasukeMenuSettingModalComponent, { data }).subscribe(
          modalRef => {
            modalRef.hide();

            if (modalRef.reason === ModalReason.Done) {
              // 一新多助メニュー設定から一新多助メニュー表示データを作成
              this.isshinTasukeMenuService.getIsshinTasukeMenuSetting(this.loginUser.blUserId!).subscribe(
                setting => {
                  this._dispIsshinTasukeMenuData = this.isshinTasukeMenuService.createIsshinTasukeMenuData(
                    setting,
                    this.bizMenuGroup,
                    this.isPermissionMaintenance(),
                    this.isPermissionCarsales(),
                    this.isPermissionRepair(),
                    this.availableServiceList,
                    this.permissionList
                  );

                  // タブオプション設定
                  this.setIsshinTasukeTabOption(setting);

                  // 表示中のタブが区分変更によりタブ一覧から無くなった場合のみ、タブを再選択する
                  // ※区分が変更されず表示中のタブがそのまま残る場合は、意図せず一新多助タブへ切り替わってしまうため再選択しない
                  const currentTabStillExists = _some(this.tabOptions, tab => tab.tabId === this.currentTab.tabId);
                  if (!currentTabStillExists) {
                    // 「非表示」区分の場合は一新多助タブ自体が存在しないため、代わりに既定タブ(通常タブの先頭)を選択する
                    const reselectTabId = setting.isshinTasukeBusinessTabDiv === IsshinTasukeBusinessTabDiv.Hide
                      ? this.tabOptionsBackup[0].tabId
                      : IsshinTasukeTabOption.tabId;
                    // ※tabContainerService.select()を直接呼ぶとURLフラグメント(タブ選択の正)が更新されず、
                    //   以後そのタブIDへのタブクリックがナビゲーション扱いされずタブ切替できなくなるため、
                    //   通常のタブクリックと同じ経路(navigateTab→フラグメント更新→selectTab)で選択する
                    // ※bl-tab-containerのitems(tabOptions)への反映を待ってからnavigateTabする必要があるため、
                    //   変更検知後の実行になるよう遅延させる(特に「単独表示」は他タブが一斉に消えるため、
                    //   遅延させないとフラグメント変更がitems反映より先に処理され再選択に失敗する)
                    _defer(() => {
                      this.navigateTab(reselectTabId);
                    });
                  }
                }
              );
            }
          }
        );
      }
    );
  }

  /**
   * 一新多助メニューコンテンツが有効な業務メニューかどうかを判定します。
   * @param menu 一新多助メニューコンテンツ
   * @returns 判定結果
   */
  private isValidBusinessMenu(menu: IIsshinTasukeMenuContent): boolean {
    return _some(
      this.businessAllMenuList,
      allMenu =>
        allMenu.businessMenuGroupId === menu.businessMenuGroupId &&
        allMenu.businessMenuContentId === menu.businessMenuContentId
    );
  }

  /**
   * 整備サービス機能権限を判定します。
   * @returns 判定結果
   */
  private isPermissionMaintenance(): boolean {
    return !_some(this.permissionList, permission => permission.blFunctionId === 'BM100-210010-E');
  }

  /**
   * 鈑金サービス機能権限を判定します。
   * @returns 判定結果
   */
  private isPermissionRepair(): boolean {
    return !_some(this.permissionList, permission => permission.blFunctionId === RoleConst.ROLEID_MENU_RPC_REPAIR_ALL);
  }

  /**
   * 車販サービス機能権限を判定します。
   * @returns 判定結果
   */
  private isPermissionCarsales(): boolean {
    return _filter(this.permissionList, permission => {
      return permission.blFunctionId === RoleConst.ROLEID_MENU_CSC_ESTINATE
        || permission.blFunctionId === RoleConst.ROLEID_MENU_CSC_ORDER
        || permission.blFunctionId === RoleConst.ROLEID_MENU_CSC_DELIVERY
        || permission.blFunctionId === RoleConst.ROLEID_MENU_CSC_PURCHASE
        || permission.blFunctionId === RoleConst.ROLEID_MENU_CSC_VEHICLESTOCK;
    }).length !== 5;
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/biz-menu-page.component.ts